// Generated from ./util_cohort_builder_grammar/stable/SubjectsVariablesLexer.g4 by ANTLR 4.13.1

import * as antlr from "antlr4ng";
import { Token } from "antlr4ng";


export class SubjectsVariablesLexer extends antlr.Lexer {
    public static readonly INDEX_DATE = 1;
    public static readonly EVENT = 2;
    public static readonly CALENDAR_DATE = 3;
    public static readonly UPPER_DATE_BOUND = 4;
    public static readonly LOWER_DATE_BOUND = 5;
    public static readonly DERIVED_EVENT_DATE = 6;
    public static readonly CONSTRAINTS = 7;
    public static readonly ANY_ORDER = 8;
    public static readonly IS_EVENT_DATE = 9;
    public static readonly TC = 10;
    public static readonly TEMPORAL_CONSTRAINT_ABBR = 11;
    public static readonly TEMPORAL_CONSTRAINT = 12;
    public static readonly POSITION = 13;
    public static readonly CF = 14;
    public static readonly CONCEPT_FILTER = 15;
    public static readonly CONCEPT_FILTER_ABBR = 16;
    public static readonly NF = 17;
    public static readonly NUMERIC_FILTER = 18;
    public static readonly NUMERIC_FILTER_ABBR = 19;
    public static readonly SF = 20;
    public static readonly STRING_FILTER = 21;
    public static readonly STRING_FILTER_ABBR = 22;
    public static readonly UF = 23;
    public static readonly UNIQUENESS_FILTER = 24;
    public static readonly UNIQUENESS_FILTER_ABBR = 25;
    public static readonly RF = 26;
    public static readonly RELATED_ENTITY_FILTER = 27;
    public static readonly RELATED_ENTITY_FILTER_ABBR = 28;
    public static readonly QUALIFIED_CARE_SITE_ALIAS = 29;
    public static readonly QUALIFIED_CONDITION_OCCURRENCE_ALIAS = 30;
    public static readonly QUALIFIED_DRUG_EXPOSURE_ALIAS = 31;
    public static readonly QUALIFIED_MEASUREMENT_ALIAS = 32;
    public static readonly QUALIFIED_OBSERVATION_ALIAS = 33;
    public static readonly QUALIFIED_PERSON_ALIAS = 34;
    public static readonly QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS = 35;
    public static readonly QUALIFIED_PROVIDER_ALIAS = 36;
    public static readonly QUALIFIED_VISIT_OCCURRENCE_ALIAS = 37;
    public static readonly QUALIFIED_DERIVED_EVENT_NAME = 38;
    public static readonly SUBJECT_VARIABLE_CARE_SITE_ALIAS = 39;
    public static readonly SUBJECT_VARIABLE_CONDITION_OCCURRENCE_ALIAS = 40;
    public static readonly SUBJECT_VARIABLE_DRUG_EXPOSURE_ALIAS = 41;
    public static readonly SUBJECT_VARIABLE_MEASUREMENT_ALIAS = 42;
    public static readonly SUBJECT_VARIABLE_OBSERVATION_ALIAS = 43;
    public static readonly SUBJECT_VARIABLE_PROCEDURE_OCCURRENCE_ALIAS = 44;
    public static readonly SUBJECT_VARIABLE_PROVIDER_ALIAS = 45;
    public static readonly SUBJECT_VARIABLE_VISIT_OCCURRENCE_ALIAS = 46;
    public static readonly SUBJECT_VARIABLE_DERIVED_EVENT_NAME = 47;
    public static readonly CONCEPT_GROUP = 48;
    public static readonly CARE_SITE_ALIAS = 49;
    public static readonly CONDITION_OCCURRENCE_ALIAS = 50;
    public static readonly DRUG_EXPOSURE_ALIAS = 51;
    public static readonly MEASUREMENT_ALIAS = 52;
    public static readonly OBSERVATION_ALIAS = 53;
    public static readonly PERSON_ALIAS = 54;
    public static readonly PROCEDURE_OCCURRENCE_ALIAS = 55;
    public static readonly PROVIDER_ALIAS = 56;
    public static readonly VISIT_OCCURRENCE_ALIAS = 57;
    public static readonly MERGED_EVENT_NAME = 58;
    public static readonly SEQUENCE_EVENT_NAME = 59;
    public static readonly INSTANCE_EVENT_NAME = 60;
    public static readonly SUBJECTS_VARIABLE_NAME = 61;
    public static readonly NAMESPACE_QUALIFIER = 62;
    public static readonly SUBJECTS_VARIABLE = 63;
    public static readonly CONCEPT = 64;
    public static readonly QUALIFIED_MERGED_EVENT = 65;
    public static readonly QUALIFIED_SEQUENCE_EVENT = 66;
    public static readonly QUALIFIED_INSTANCE_EVENT = 67;
    public static readonly SUBJECT_VARIABLE_MERGED_EVENT = 68;
    public static readonly SUBJECT_VARIABLE_SEQUENCE_EVENT = 69;
    public static readonly SUBJECT_VARIABLE_INSTANCE_EVENT = 70;
    public static readonly MERGED_EVENT = 71;
    public static readonly SEQUENCE_EVENT = 72;
    public static readonly INSTANCE_EVENT = 73;
    public static readonly DERIVED_EVENT = 74;
    public static readonly LINE_COMMENT = 75;
    public static readonly INT = 76;
    public static readonly M = 77;
    public static readonly D = 78;
    public static readonly Y = 79;
    public static readonly DATE = 80;
    public static readonly OPEN_PAREN = 81;
    public static readonly CLOSE_PAREN = 82;
    public static readonly SEMICOLON = 83;
    public static readonly COMMA = 84;
    public static readonly EQ = 85;
    public static readonly MULTIPLY = 86;
    public static readonly DIVIDE = 87;
    public static readonly ADD = 88;
    public static readonly SUBTRACT = 89;
    public static readonly CONTAINS = 90;
    public static readonly NEQ = 91;
    public static readonly LTE = 92;
    public static readonly GTE = 93;
    public static readonly LT = 94;
    public static readonly GT = 95;
    public static readonly MAX = 96;
    public static readonly MIN = 97;
    public static readonly AVG = 98;
    public static readonly COUNT = 99;
    public static readonly LEAST = 100;
    public static readonly GREATEST = 101;
    public static readonly IN = 102;
    public static readonly AND = 103;
    public static readonly OR = 104;
    public static readonly NOT = 105;
    public static readonly COMPLEMENT = 106;
    public static readonly UNION = 107;
    public static readonly INTERSECTION = 108;
    public static readonly DIFFERENCE = 109;
    public static readonly INDEX = 110;
    public static readonly TIME_UNIT = 111;
    public static readonly DAYS = 112;
    public static readonly WEEKS = 113;
    public static readonly MONTHS = 114;
    public static readonly YEARS = 115;
    public static readonly MINIMUM_BETWEEN = 116;
    public static readonly MAXIMUM_BETWEEN = 117;
    public static readonly TOTAL_BETWEEN = 118;
    public static readonly FIXED_WINDOW = 119;
    public static readonly ROLLING_WINDOW = 120;
    public static readonly PERIOD = 121;
    public static readonly WS = 122;
    public static readonly CARE_SITE = 123;
    public static readonly CONDITION_OCCURRENCE = 124;
    public static readonly DRUG_EXPOSURE = 125;
    public static readonly MEASUREMENT = 126;
    public static readonly OBSERVATION = 127;
    public static readonly PERSON = 128;
    public static readonly PROCEDURE_OCCURRENCE = 129;
    public static readonly PROVIDER = 130;
    public static readonly VISIT_OCCURRENCE = 131;
    public static readonly QUALIFIED_CARE_SITE = 132;
    public static readonly QUALIFIED_CONDITION_OCCURRENCE = 133;
    public static readonly QUALIFIED_DRUG_EXPOSURE = 134;
    public static readonly QUALIFIED_MEASUREMENT = 135;
    public static readonly QUALIFIED_OBSERVATION = 136;
    public static readonly QUALIFIED_PERSON = 137;
    public static readonly QUALIFIED_PROCEDURE_OCCURRENCE = 138;
    public static readonly QUALIFIED_PROVIDER = 139;
    public static readonly QUALIFIED_VISIT_OCCURRENCE = 140;
    public static readonly SUBJECT_VARIABLE_CARE_SITE = 141;
    public static readonly SUBJECT_VARIABLE_CONDITION_OCCURRENCE = 142;
    public static readonly SUBJECT_VARIABLE_DRUG_EXPOSURE = 143;
    public static readonly SUBJECT_VARIABLE_MEASUREMENT = 144;
    public static readonly SUBJECT_VARIABLE_OBSERVATION = 145;
    public static readonly SUBJECT_VARIABLE_PERSON = 146;
    public static readonly SUBJECT_VARIABLE_PROCEDURE_OCCURRENCE = 147;
    public static readonly SUBJECT_VARIABLE_PROVIDER = 148;
    public static readonly SUBJECT_VARIABLE_VISIT_OCCURRENCE = 149;
    public static readonly CONDITION_OCCURRENCE_DATE_ATTRIBUTE = 150;
    public static readonly DRUG_EXPOSURE_DATE_ATTRIBUTE = 151;
    public static readonly MEASUREMENT_DATE_ATTRIBUTE = 152;
    public static readonly OBSERVATION_DATE_ATTRIBUTE = 153;
    public static readonly PROCEDURE_OCCURRENCE_DATE_ATTRIBUTE = 154;
    public static readonly VISIT_OCCURRENCE_DATE_ATTRIBUTE = 155;
    public static readonly PERSON_DATE_TIME_ATTRIBUTE = 156;
    public static readonly DRUG_EXPOSURE_INT_ATTRIBUTE = 157;
    public static readonly MEASUREMENT_FLOAT_ATTRIBUTE = 158;
    public static readonly PERSON_INT_ATTRIBUTE = 159;
    public static readonly COMMON_NUMERIC_FLOAT_ATTRIBUTE = 160;
    public static readonly QUANTITY = 161;
    public static readonly CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE = 162;
    public static readonly DRUG_EXPOSURE_CONCEPT_ATTRIBUTE = 163;
    public static readonly MEASUREMENT_CONCEPT_ATTRIBUTE = 164;
    public static readonly OBSERVATION_CONCEPT_ATTRIBUTE = 165;
    public static readonly PERSON_CONCEPT_ATTRIBUTE = 166;
    public static readonly PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE = 167;
    public static readonly PROVIDER_CONCEPT_ATTRIBUTE = 168;
    public static readonly VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE = 169;
    public static readonly COMMON_CONCEPT_ATTRIBUTE = 170;
    public static readonly CARE_SITE_CONCEPT_ATTRIBUTE = 171;
    public static readonly COMMON_STRING_ATTRIBUTE = 172;
    public static readonly GENDER_SOURCE_VALUE = 173;
    public static readonly CARE_SITE_STRING_ATTRIBUTE = 174;
    public static readonly CONDITION_OCCURRENCE_STRING_ATTRIBUTE = 175;
    public static readonly DRUG_EXPOSURE_STRING_ATTRIBUTE = 176;
    public static readonly MEASUREMENT_STRING_ATTRIBUTE = 177;
    public static readonly OBSERVATION_STRING_ATTRIBUTE = 178;
    public static readonly PERSON_STRING_ATTRIBUTE = 179;
    public static readonly PROCEDURE_OCCURRENCE_STRING_ATTRIBUTE = 180;
    public static readonly PROVIDER_STRING_ATTRIBUTE = 181;
    public static readonly VISIT_OCCURRENCE_STRING_ATTRIBUTE = 182;

    public static readonly channelNames = [
        "DEFAULT_TOKEN_CHANNEL", "HIDDEN"
    ];

    public static readonly literalNames = [
        null, "'INDEX_DATE'", "'EVENT'", "'CALENDAR_DATE'", "'UPPER_DATE_BOUND'", 
        "'LOWER_DATE_BOUND'", "'derived_event_date'", "'CONSTRAINTS'", "'ANY_ORDER'", 
        "'IS_EVENT_DATE'", null, "'TC'", "'TEMPORAL_CONSTRAINT'", "'POSITION'", 
        null, "'CONCEPT_FILTER'", "'CF'", null, "'NUMERIC_FILTER'", "'NF'", 
        null, "'STRING_FILTER'", "'SF'", null, "'UNIQUENESS_FILTER'", "'UF'", 
        null, "'RELATED_ENTITY_FILTER'", "'RF'", null, null, null, null, 
        null, null, null, null, null, null, null, null, null, null, null, 
        null, null, null, null, null, null, null, null, null, null, null, 
        null, null, null, null, null, null, null, "'::'", "'SUBJECTS_VARIABLE'", 
        null, "'QUALIFIED_MERGED_EVENT'", "'QUALIFIED_SEQUENCE_EVENT'", 
        "'QUALIFIED_INSTANCE_EVENT'", "'SUBJECT_VARIABLE_MERGED_EVENT'", 
        "'SUBJECT_VARIABLE_SEQUENCE_EVENT'", "'SUBJECT_VARIABLE_INSTANCE_EVENT'", 
        "'MERGED_EVENT'", "'SEQUENCE_EVENT'", "'INSTANCE_EVENT'", "'DERIVED_EVENT'", 
        null, null, null, null, null, null, "'('", "')'", "';'", "','", 
        "'='", "'*'", "'/'", "'+'", "'-'", "'CONTAINS'", "'!='", "'<='", 
        "'>='", "'<'", "'>'", "'MAX'", "'MIN'", "'AVG'", "'COUNT'", "'LEAST'", 
        "'GREATEST'", "'IN'", "'AND'", "'OR'", "'NOT'", "'COMPLEMENT'", 
        "'UNION'", "'INTERSECTION'", "'DIFFERENCE'", "'INDEX'", null, "'DAYS'", 
        "'WEEKS'", "'MONTHS'", "'YEARS'", "'MINIMUM_BETWEEN'", "'MAXIMUM_BETWEEN'", 
        "'TOTAL_BETWEEN'", "'FIXED_WINDOW'", "'ROLLING_WINDOW'", "'.'", 
        null, "'CARE_SITE'", "'CONDITION_OCCURRENCE'", "'DRUG_EXPOSURE'", 
        "'MEASUREMENT'", "'OBSERVATION'", "'PERSON'", "'PROCEDURE_OCCURRENCE'", 
        "'PROVIDER'", "'VISIT_OCCURRENCE'", "'QUALIFIED_CARE_SITE'", "'QUALIFIED_CONDITION_OCCURRENCE'", 
        "'QUALIFIED_DRUG_EXPOSURE'", "'QUALIFIED_MEASUREMENT'", "'QUALIFIED_OBSERVATION'", 
        "'QUALIFIED_PERSON'", "'QUALIFIED_PROCEDURE_OCCURRENCE'", "'QUALIFIED_PROVIDER'", 
        "'QUALIFIED_VISIT_OCCURRENCE'", "'SUBJECT_VARIABLE_CARE_SITE'", 
        "'SUBJECT_VARIABLE_CONDITION_OCCURRENCE'", "'SUBJECT_VARIABLE_DRUG_EXPOSURE'", 
        "'SUBJECT_VARIABLE_MEASUREMENT'", "'SUBJECT_VARIABLE_OBSERVATION'", 
        "'SUBJECT_VARIABLE_PERSON'", "'SUBJECT_VARIABLE_PROCEDURE_OCCURRENCE'", 
        "'SUBJECT_VARIABLE_PROVIDER'", "'SUBJECT_VARIABLE_VISIT_OCCURRENCE'", 
        null, null, "'measurement_date'", "'observation_date'", "'procedure_date'", 
        null, "'birth_datetime'", null, null, null, "'value_as_number'", 
        "'quantity'", null, null, null, null, null, null, "'specialty_concept'", 
        null, null, "'place_of_service_concept'", "'value_as_string'", "'gender_source_value'"
    ];

    public static readonly symbolicNames = [
        null, "INDEX_DATE", "EVENT", "CALENDAR_DATE", "UPPER_DATE_BOUND", 
        "LOWER_DATE_BOUND", "DERIVED_EVENT_DATE", "CONSTRAINTS", "ANY_ORDER", 
        "IS_EVENT_DATE", "TC", "TEMPORAL_CONSTRAINT_ABBR", "TEMPORAL_CONSTRAINT", 
        "POSITION", "CF", "CONCEPT_FILTER", "CONCEPT_FILTER_ABBR", "NF", 
        "NUMERIC_FILTER", "NUMERIC_FILTER_ABBR", "SF", "STRING_FILTER", 
        "STRING_FILTER_ABBR", "UF", "UNIQUENESS_FILTER", "UNIQUENESS_FILTER_ABBR", 
        "RF", "RELATED_ENTITY_FILTER", "RELATED_ENTITY_FILTER_ABBR", "QUALIFIED_CARE_SITE_ALIAS", 
        "QUALIFIED_CONDITION_OCCURRENCE_ALIAS", "QUALIFIED_DRUG_EXPOSURE_ALIAS", 
        "QUALIFIED_MEASUREMENT_ALIAS", "QUALIFIED_OBSERVATION_ALIAS", "QUALIFIED_PERSON_ALIAS", 
        "QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS", "QUALIFIED_PROVIDER_ALIAS", 
        "QUALIFIED_VISIT_OCCURRENCE_ALIAS", "QUALIFIED_DERIVED_EVENT_NAME", 
        "SUBJECT_VARIABLE_CARE_SITE_ALIAS", "SUBJECT_VARIABLE_CONDITION_OCCURRENCE_ALIAS", 
        "SUBJECT_VARIABLE_DRUG_EXPOSURE_ALIAS", "SUBJECT_VARIABLE_MEASUREMENT_ALIAS", 
        "SUBJECT_VARIABLE_OBSERVATION_ALIAS", "SUBJECT_VARIABLE_PROCEDURE_OCCURRENCE_ALIAS", 
        "SUBJECT_VARIABLE_PROVIDER_ALIAS", "SUBJECT_VARIABLE_VISIT_OCCURRENCE_ALIAS", 
        "SUBJECT_VARIABLE_DERIVED_EVENT_NAME", "CONCEPT_GROUP", "CARE_SITE_ALIAS", 
        "CONDITION_OCCURRENCE_ALIAS", "DRUG_EXPOSURE_ALIAS", "MEASUREMENT_ALIAS", 
        "OBSERVATION_ALIAS", "PERSON_ALIAS", "PROCEDURE_OCCURRENCE_ALIAS", 
        "PROVIDER_ALIAS", "VISIT_OCCURRENCE_ALIAS", "MERGED_EVENT_NAME", 
        "SEQUENCE_EVENT_NAME", "INSTANCE_EVENT_NAME", "SUBJECTS_VARIABLE_NAME", 
        "NAMESPACE_QUALIFIER", "SUBJECTS_VARIABLE", "CONCEPT", "QUALIFIED_MERGED_EVENT", 
        "QUALIFIED_SEQUENCE_EVENT", "QUALIFIED_INSTANCE_EVENT", "SUBJECT_VARIABLE_MERGED_EVENT", 
        "SUBJECT_VARIABLE_SEQUENCE_EVENT", "SUBJECT_VARIABLE_INSTANCE_EVENT", 
        "MERGED_EVENT", "SEQUENCE_EVENT", "INSTANCE_EVENT", "DERIVED_EVENT", 
        "LINE_COMMENT", "INT", "M", "D", "Y", "DATE", "OPEN_PAREN", "CLOSE_PAREN", 
        "SEMICOLON", "COMMA", "EQ", "MULTIPLY", "DIVIDE", "ADD", "SUBTRACT", 
        "CONTAINS", "NEQ", "LTE", "GTE", "LT", "GT", "MAX", "MIN", "AVG", 
        "COUNT", "LEAST", "GREATEST", "IN", "AND", "OR", "NOT", "COMPLEMENT", 
        "UNION", "INTERSECTION", "DIFFERENCE", "INDEX", "TIME_UNIT", "DAYS", 
        "WEEKS", "MONTHS", "YEARS", "MINIMUM_BETWEEN", "MAXIMUM_BETWEEN", 
        "TOTAL_BETWEEN", "FIXED_WINDOW", "ROLLING_WINDOW", "PERIOD", "WS", 
        "CARE_SITE", "CONDITION_OCCURRENCE", "DRUG_EXPOSURE", "MEASUREMENT", 
        "OBSERVATION", "PERSON", "PROCEDURE_OCCURRENCE", "PROVIDER", "VISIT_OCCURRENCE", 
        "QUALIFIED_CARE_SITE", "QUALIFIED_CONDITION_OCCURRENCE", "QUALIFIED_DRUG_EXPOSURE", 
        "QUALIFIED_MEASUREMENT", "QUALIFIED_OBSERVATION", "QUALIFIED_PERSON", 
        "QUALIFIED_PROCEDURE_OCCURRENCE", "QUALIFIED_PROVIDER", "QUALIFIED_VISIT_OCCURRENCE", 
        "SUBJECT_VARIABLE_CARE_SITE", "SUBJECT_VARIABLE_CONDITION_OCCURRENCE", 
        "SUBJECT_VARIABLE_DRUG_EXPOSURE", "SUBJECT_VARIABLE_MEASUREMENT", 
        "SUBJECT_VARIABLE_OBSERVATION", "SUBJECT_VARIABLE_PERSON", "SUBJECT_VARIABLE_PROCEDURE_OCCURRENCE", 
        "SUBJECT_VARIABLE_PROVIDER", "SUBJECT_VARIABLE_VISIT_OCCURRENCE", 
        "CONDITION_OCCURRENCE_DATE_ATTRIBUTE", "DRUG_EXPOSURE_DATE_ATTRIBUTE", 
        "MEASUREMENT_DATE_ATTRIBUTE", "OBSERVATION_DATE_ATTRIBUTE", "PROCEDURE_OCCURRENCE_DATE_ATTRIBUTE", 
        "VISIT_OCCURRENCE_DATE_ATTRIBUTE", "PERSON_DATE_TIME_ATTRIBUTE", 
        "DRUG_EXPOSURE_INT_ATTRIBUTE", "MEASUREMENT_FLOAT_ATTRIBUTE", "PERSON_INT_ATTRIBUTE", 
        "COMMON_NUMERIC_FLOAT_ATTRIBUTE", "QUANTITY", "CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE", 
        "DRUG_EXPOSURE_CONCEPT_ATTRIBUTE", "MEASUREMENT_CONCEPT_ATTRIBUTE", 
        "OBSERVATION_CONCEPT_ATTRIBUTE", "PERSON_CONCEPT_ATTRIBUTE", "PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE", 
        "PROVIDER_CONCEPT_ATTRIBUTE", "VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE", 
        "COMMON_CONCEPT_ATTRIBUTE", "CARE_SITE_CONCEPT_ATTRIBUTE", "COMMON_STRING_ATTRIBUTE", 
        "GENDER_SOURCE_VALUE", "CARE_SITE_STRING_ATTRIBUTE", "CONDITION_OCCURRENCE_STRING_ATTRIBUTE", 
        "DRUG_EXPOSURE_STRING_ATTRIBUTE", "MEASUREMENT_STRING_ATTRIBUTE", 
        "OBSERVATION_STRING_ATTRIBUTE", "PERSON_STRING_ATTRIBUTE", "PROCEDURE_OCCURRENCE_STRING_ATTRIBUTE", 
        "PROVIDER_STRING_ATTRIBUTE", "VISIT_OCCURRENCE_STRING_ATTRIBUTE"
    ];

    public static readonly modeNames = [
        "DEFAULT_MODE",
    ];

    public static readonly ruleNames = [
        "INDEX_DATE", "EVENT", "CALENDAR_DATE", "UPPER_DATE_BOUND", "LOWER_DATE_BOUND", 
        "DERIVED_EVENT_DATE", "CONSTRAINTS", "ANY_ORDER", "IS_EVENT_DATE", 
        "TC", "TEMPORAL_CONSTRAINT_ABBR", "TEMPORAL_CONSTRAINT", "POSITION", 
        "CF", "CONCEPT_FILTER", "CONCEPT_FILTER_ABBR", "NF", "NUMERIC_FILTER", 
        "NUMERIC_FILTER_ABBR", "SF", "STRING_FILTER", "STRING_FILTER_ABBR", 
        "UF", "UNIQUENESS_FILTER", "UNIQUENESS_FILTER_ABBR", "RF", "RELATED_ENTITY_FILTER", 
        "RELATED_ENTITY_FILTER_ABBR", "QUALIFIED_CARE_SITE_ALIAS", "QUALIFIED_CONDITION_OCCURRENCE_ALIAS", 
        "QUALIFIED_DRUG_EXPOSURE_ALIAS", "QUALIFIED_MEASUREMENT_ALIAS", 
        "QUALIFIED_OBSERVATION_ALIAS", "QUALIFIED_PERSON_ALIAS", "QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS", 
        "QUALIFIED_PROVIDER_ALIAS", "QUALIFIED_VISIT_OCCURRENCE_ALIAS", 
        "QUALIFIED_DERIVED_EVENT_NAME", "SUBJECT_VARIABLE_CARE_SITE_ALIAS", 
        "SUBJECT_VARIABLE_CONDITION_OCCURRENCE_ALIAS", "SUBJECT_VARIABLE_DRUG_EXPOSURE_ALIAS", 
        "SUBJECT_VARIABLE_MEASUREMENT_ALIAS", "SUBJECT_VARIABLE_OBSERVATION_ALIAS", 
        "SUBJECT_VARIABLE_PROCEDURE_OCCURRENCE_ALIAS", "SUBJECT_VARIABLE_PROVIDER_ALIAS", 
        "SUBJECT_VARIABLE_VISIT_OCCURRENCE_ALIAS", "SUBJECT_VARIABLE_DERIVED_EVENT_NAME", 
        "CONCEPT_GROUP", "CARE_SITE_ALIAS", "CONDITION_OCCURRENCE_ALIAS", 
        "DRUG_EXPOSURE_ALIAS", "MEASUREMENT_ALIAS", "OBSERVATION_ALIAS", 
        "PERSON_ALIAS", "PROCEDURE_OCCURRENCE_ALIAS", "PROVIDER_ALIAS", 
        "VISIT_OCCURRENCE_ALIAS", "MERGED_EVENT_NAME", "SEQUENCE_EVENT_NAME", 
        "INSTANCE_EVENT_NAME", "SUBJECTS_VARIABLE_NAME", "NAMESPACE_QUALIFIER", 
        "SUBJECTS_VARIABLE", "CONCEPT", "QUALIFIED_MERGED_EVENT", "QUALIFIED_SEQUENCE_EVENT", 
        "QUALIFIED_INSTANCE_EVENT", "SUBJECT_VARIABLE_MERGED_EVENT", "SUBJECT_VARIABLE_SEQUENCE_EVENT", 
        "SUBJECT_VARIABLE_INSTANCE_EVENT", "MERGED_EVENT", "SEQUENCE_EVENT", 
        "INSTANCE_EVENT", "DERIVED_EVENT", "LINE_COMMENT", "INT", "M", "D", 
        "Y", "DATE", "OPEN_PAREN", "CLOSE_PAREN", "SEMICOLON", "COMMA", 
        "LABEL", "ALPHA", "ALPHA_NUMERIC", "NON_ALPHA_NUMERIC", "SPECIAL_CHAR", 
        "EQ", "MULTIPLY", "DIVIDE", "ADD", "SUBTRACT", "CONTAINS", "NEQ", 
        "LTE", "GTE", "LT", "GT", "MAX", "MIN", "AVG", "COUNT", "LEAST", 
        "GREATEST", "IN", "AND", "OR", "NOT", "COMPLEMENT", "UNION", "INTERSECTION", 
        "DIFFERENCE", "INDEX", "TIME_UNIT", "DAYS", "WEEKS", "MONTHS", "YEARS", 
        "MINIMUM_BETWEEN", "MAXIMUM_BETWEEN", "TOTAL_BETWEEN", "FIXED_WINDOW", 
        "ROLLING_WINDOW", "PERIOD", "WS", "CARE_SITE", "CONDITION_OCCURRENCE", 
        "DRUG_EXPOSURE", "MEASUREMENT", "OBSERVATION", "PERSON", "PROCEDURE_OCCURRENCE", 
        "PROVIDER", "VISIT_OCCURRENCE", "QUALIFIED_CARE_SITE", "QUALIFIED_CONDITION_OCCURRENCE", 
        "QUALIFIED_DRUG_EXPOSURE", "QUALIFIED_MEASUREMENT", "QUALIFIED_OBSERVATION", 
        "QUALIFIED_PERSON", "QUALIFIED_PROCEDURE_OCCURRENCE", "QUALIFIED_PROVIDER", 
        "QUALIFIED_VISIT_OCCURRENCE", "SUBJECT_VARIABLE_CARE_SITE", "SUBJECT_VARIABLE_CONDITION_OCCURRENCE", 
        "SUBJECT_VARIABLE_DRUG_EXPOSURE", "SUBJECT_VARIABLE_MEASUREMENT", 
        "SUBJECT_VARIABLE_OBSERVATION", "SUBJECT_VARIABLE_PERSON", "SUBJECT_VARIABLE_PROCEDURE_OCCURRENCE", 
        "SUBJECT_VARIABLE_PROVIDER", "SUBJECT_VARIABLE_VISIT_OCCURRENCE", 
        "CONDITION_OCCURRENCE_DATE_ATTRIBUTE", "DRUG_EXPOSURE_DATE_ATTRIBUTE", 
        "MEASUREMENT_DATE_ATTRIBUTE", "OBSERVATION_DATE_ATTRIBUTE", "PROCEDURE_OCCURRENCE_DATE_ATTRIBUTE", 
        "VISIT_OCCURRENCE_DATE_ATTRIBUTE", "PERSON_DATE_TIME_ATTRIBUTE", 
        "DRUG_EXPOSURE_INT_ATTRIBUTE", "MEASUREMENT_FLOAT_ATTRIBUTE", "PERSON_INT_ATTRIBUTE", 
        "COMMON_NUMERIC_FLOAT_ATTRIBUTE", "QUANTITY", "CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE", 
        "DRUG_EXPOSURE_CONCEPT_ATTRIBUTE", "MEASUREMENT_CONCEPT_ATTRIBUTE", 
        "OBSERVATION_CONCEPT_ATTRIBUTE", "PERSON_CONCEPT_ATTRIBUTE", "PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE", 
        "PROVIDER_CONCEPT_ATTRIBUTE", "VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE", 
        "COMMON_CONCEPT_ATTRIBUTE", "CARE_SITE_CONCEPT_ATTRIBUTE", "COMMON_STRING_ATTRIBUTE", 
        "GENDER_SOURCE_VALUE", "CARE_SITE_STRING_ATTRIBUTE", "CONDITION_OCCURRENCE_STRING_ATTRIBUTE", 
        "DRUG_EXPOSURE_STRING_ATTRIBUTE", "MEASUREMENT_STRING_ATTRIBUTE", 
        "OBSERVATION_STRING_ATTRIBUTE", "PERSON_STRING_ATTRIBUTE", "PROCEDURE_OCCURRENCE_STRING_ATTRIBUTE", 
        "PROVIDER_STRING_ATTRIBUTE", "VISIT_OCCURRENCE_STRING_ATTRIBUTE",
    ];


    public constructor(input: antlr.CharStream) {
        super(input);
        this.interpreter = new antlr.LexerATNSimulator(this, SubjectsVariablesLexer._ATN, SubjectsVariablesLexer.decisionsToDFA, new antlr.PredictionContextCache());
    }

    public get grammarFileName(): string { return "SubjectsVariablesLexer.g4"; }

    public get literalNames(): (string | null)[] { return SubjectsVariablesLexer.literalNames; }
    public get symbolicNames(): (string | null)[] { return SubjectsVariablesLexer.symbolicNames; }
    public get ruleNames(): string[] { return SubjectsVariablesLexer.ruleNames; }

    public get serializedATN(): number[] { return SubjectsVariablesLexer._serializedATN; }

    public get channelNames(): string[] { return SubjectsVariablesLexer.channelNames; }

    public get modeNames(): string[] { return SubjectsVariablesLexer.modeNames; }

    public static readonly _serializedATN: number[] = [
        4,0,182,3400,6,-1,2,0,7,0,2,1,7,1,2,2,7,2,2,3,7,3,2,4,7,4,2,5,7,
        5,2,6,7,6,2,7,7,7,2,8,7,8,2,9,7,9,2,10,7,10,2,11,7,11,2,12,7,12,
        2,13,7,13,2,14,7,14,2,15,7,15,2,16,7,16,2,17,7,17,2,18,7,18,2,19,
        7,19,2,20,7,20,2,21,7,21,2,22,7,22,2,23,7,23,2,24,7,24,2,25,7,25,
        2,26,7,26,2,27,7,27,2,28,7,28,2,29,7,29,2,30,7,30,2,31,7,31,2,32,
        7,32,2,33,7,33,2,34,7,34,2,35,7,35,2,36,7,36,2,37,7,37,2,38,7,38,
        2,39,7,39,2,40,7,40,2,41,7,41,2,42,7,42,2,43,7,43,2,44,7,44,2,45,
        7,45,2,46,7,46,2,47,7,47,2,48,7,48,2,49,7,49,2,50,7,50,2,51,7,51,
        2,52,7,52,2,53,7,53,2,54,7,54,2,55,7,55,2,56,7,56,2,57,7,57,2,58,
        7,58,2,59,7,59,2,60,7,60,2,61,7,61,2,62,7,62,2,63,7,63,2,64,7,64,
        2,65,7,65,2,66,7,66,2,67,7,67,2,68,7,68,2,69,7,69,2,70,7,70,2,71,
        7,71,2,72,7,72,2,73,7,73,2,74,7,74,2,75,7,75,2,76,7,76,2,77,7,77,
        2,78,7,78,2,79,7,79,2,80,7,80,2,81,7,81,2,82,7,82,2,83,7,83,2,84,
        7,84,2,85,7,85,2,86,7,86,2,87,7,87,2,88,7,88,2,89,7,89,2,90,7,90,
        2,91,7,91,2,92,7,92,2,93,7,93,2,94,7,94,2,95,7,95,2,96,7,96,2,97,
        7,97,2,98,7,98,2,99,7,99,2,100,7,100,2,101,7,101,2,102,7,102,2,103,
        7,103,2,104,7,104,2,105,7,105,2,106,7,106,2,107,7,107,2,108,7,108,
        2,109,7,109,2,110,7,110,2,111,7,111,2,112,7,112,2,113,7,113,2,114,
        7,114,2,115,7,115,2,116,7,116,2,117,7,117,2,118,7,118,2,119,7,119,
        2,120,7,120,2,121,7,121,2,122,7,122,2,123,7,123,2,124,7,124,2,125,
        7,125,2,126,7,126,2,127,7,127,2,128,7,128,2,129,7,129,2,130,7,130,
        2,131,7,131,2,132,7,132,2,133,7,133,2,134,7,134,2,135,7,135,2,136,
        7,136,2,137,7,137,2,138,7,138,2,139,7,139,2,140,7,140,2,141,7,141,
        2,142,7,142,2,143,7,143,2,144,7,144,2,145,7,145,2,146,7,146,2,147,
        7,147,2,148,7,148,2,149,7,149,2,150,7,150,2,151,7,151,2,152,7,152,
        2,153,7,153,2,154,7,154,2,155,7,155,2,156,7,156,2,157,7,157,2,158,
        7,158,2,159,7,159,2,160,7,160,2,161,7,161,2,162,7,162,2,163,7,163,
        2,164,7,164,2,165,7,165,2,166,7,166,2,167,7,167,2,168,7,168,2,169,
        7,169,2,170,7,170,2,171,7,171,2,172,7,172,2,173,7,173,2,174,7,174,
        2,175,7,175,2,176,7,176,2,177,7,177,2,178,7,178,2,179,7,179,2,180,
        7,180,2,181,7,181,2,182,7,182,2,183,7,183,2,184,7,184,2,185,7,185,
        2,186,7,186,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,1,1,1,
        1,1,1,1,1,1,1,1,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,
        1,2,1,2,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,
        1,3,1,3,1,3,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,
        1,4,1,4,1,4,1,4,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,
        1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,6,1,6,1,6,1,6,1,6,1,6,1,6,1,6,1,6,
        1,6,1,6,1,6,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,8,1,8,1,8,
        1,8,1,8,1,8,1,8,1,8,1,8,1,8,1,8,1,8,1,8,1,8,1,9,1,9,3,9,498,8,9,
        1,10,1,10,1,10,1,11,1,11,1,11,1,11,1,11,1,11,1,11,1,11,1,11,1,11,
        1,11,1,11,1,11,1,11,1,11,1,11,1,11,1,11,1,11,1,11,1,12,1,12,1,12,
        1,12,1,12,1,12,1,12,1,12,1,12,1,13,1,13,3,13,534,8,13,1,14,1,14,
        1,14,1,14,1,14,1,14,1,14,1,14,1,14,1,14,1,14,1,14,1,14,1,14,1,14,
        1,15,1,15,1,15,1,16,1,16,3,16,556,8,16,1,17,1,17,1,17,1,17,1,17,
        1,17,1,17,1,17,1,17,1,17,1,17,1,17,1,17,1,17,1,17,1,18,1,18,1,18,
        1,19,1,19,3,19,578,8,19,1,20,1,20,1,20,1,20,1,20,1,20,1,20,1,20,
        1,20,1,20,1,20,1,20,1,20,1,20,1,21,1,21,1,21,1,22,1,22,3,22,599,
        8,22,1,23,1,23,1,23,1,23,1,23,1,23,1,23,1,23,1,23,1,23,1,23,1,23,
        1,23,1,23,1,23,1,23,1,23,1,23,1,24,1,24,1,24,1,25,1,25,3,25,624,
        8,25,1,26,1,26,1,26,1,26,1,26,1,26,1,26,1,26,1,26,1,26,1,26,1,26,
        1,26,1,26,1,26,1,26,1,26,1,26,1,26,1,26,1,26,1,26,1,27,1,27,1,27,
        1,28,1,28,1,28,1,28,1,29,1,29,1,29,1,29,1,30,1,30,1,30,1,30,1,31,
        1,31,1,31,1,31,1,32,1,32,1,32,1,32,1,33,1,33,1,33,1,33,1,34,1,34,
        1,34,1,34,1,35,1,35,1,35,1,35,1,36,1,36,1,36,1,36,1,37,1,37,1,37,
        3,37,690,8,37,1,37,1,37,1,37,1,38,1,38,1,38,1,38,1,39,1,39,1,39,
        1,39,1,40,1,40,1,40,1,40,1,41,1,41,1,41,1,41,1,42,1,42,1,42,1,42,
        1,43,1,43,1,43,1,43,1,44,1,44,1,44,1,44,1,45,1,45,1,45,1,45,1,46,
        1,46,1,46,3,46,730,8,46,1,46,1,46,1,46,1,47,1,47,1,47,1,47,1,47,
        1,47,1,47,1,47,1,47,1,47,1,47,1,47,1,47,1,47,1,47,1,47,1,47,1,48,
        1,48,1,48,1,48,1,49,1,49,1,49,1,49,1,50,1,50,1,50,1,50,1,51,1,51,
        1,51,1,51,1,52,1,52,1,52,1,52,1,53,1,53,1,53,1,53,1,54,1,54,1,54,
        1,54,1,55,1,55,1,55,1,55,1,56,1,56,1,56,1,56,1,57,1,57,1,57,1,57,
        1,58,1,58,1,58,1,58,1,59,1,59,1,59,1,59,1,60,1,60,1,60,1,60,1,61,
        1,61,1,61,1,62,1,62,1,62,1,62,1,62,1,62,1,62,1,62,1,62,1,62,1,62,
        1,62,1,62,1,62,1,62,1,62,1,62,1,62,1,63,4,63,826,8,63,11,63,12,63,
        827,1,63,1,63,4,63,832,8,63,11,63,12,63,833,1,64,1,64,1,64,1,64,
        1,64,1,64,1,64,1,64,1,64,1,64,1,64,1,64,1,64,1,64,1,64,1,64,1,64,
        1,64,1,64,1,64,1,64,1,64,1,64,1,65,1,65,1,65,1,65,1,65,1,65,1,65,
        1,65,1,65,1,65,1,65,1,65,1,65,1,65,1,65,1,65,1,65,1,65,1,65,1,65,
        1,65,1,65,1,65,1,65,1,65,1,66,1,66,1,66,1,66,1,66,1,66,1,66,1,66,
        1,66,1,66,1,66,1,66,1,66,1,66,1,66,1,66,1,66,1,66,1,66,1,66,1,66,
        1,66,1,66,1,66,1,66,1,67,1,67,1,67,1,67,1,67,1,67,1,67,1,67,1,67,
        1,67,1,67,1,67,1,67,1,67,1,67,1,67,1,67,1,67,1,67,1,67,1,67,1,67,
        1,67,1,67,1,67,1,67,1,67,1,67,1,67,1,67,1,68,1,68,1,68,1,68,1,68,
        1,68,1,68,1,68,1,68,1,68,1,68,1,68,1,68,1,68,1,68,1,68,1,68,1,68,
        1,68,1,68,1,68,1,68,1,68,1,68,1,68,1,68,1,68,1,68,1,68,1,68,1,68,
        1,68,1,69,1,69,1,69,1,69,1,69,1,69,1,69,1,69,1,69,1,69,1,69,1,69,
        1,69,1,69,1,69,1,69,1,69,1,69,1,69,1,69,1,69,1,69,1,69,1,69,1,69,
        1,69,1,69,1,69,1,69,1,69,1,69,1,69,1,70,1,70,1,70,1,70,1,70,1,70,
        1,70,1,70,1,70,1,70,1,70,1,70,1,70,1,71,1,71,1,71,1,71,1,71,1,71,
        1,71,1,71,1,71,1,71,1,71,1,71,1,71,1,71,1,71,1,72,1,72,1,72,1,72,
        1,72,1,72,1,72,1,72,1,72,1,72,1,72,1,72,1,72,1,72,1,72,1,73,1,73,
        1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,73,1,74,
        1,74,1,74,1,74,5,74,1064,8,74,10,74,12,74,1067,9,74,1,74,1,74,1,
        75,4,75,1072,8,75,11,75,12,75,1073,1,76,1,76,1,76,1,76,3,76,1080,
        8,76,1,77,1,77,1,77,1,77,1,77,1,77,3,77,1088,8,77,1,78,1,78,1,78,
        1,78,1,78,1,79,1,79,1,79,1,79,1,79,1,79,1,80,1,80,1,81,1,81,1,82,
        1,82,1,83,1,83,1,84,1,84,1,84,1,84,4,84,1113,8,84,11,84,12,84,1114,
        1,84,1,84,1,85,1,85,1,86,1,86,3,86,1123,8,86,1,87,1,87,1,88,1,88,
        1,89,1,89,1,90,1,90,1,91,1,91,1,92,1,92,1,93,1,93,1,94,1,94,1,94,
        1,94,1,94,1,94,1,94,1,94,1,94,1,95,1,95,1,95,1,96,1,96,1,96,1,97,
        1,97,1,97,1,98,1,98,1,99,1,99,1,100,1,100,1,100,1,100,1,101,1,101,
        1,101,1,101,1,102,1,102,1,102,1,102,1,103,1,103,1,103,1,103,1,103,
        1,103,1,104,1,104,1,104,1,104,1,104,1,104,1,105,1,105,1,105,1,105,
        1,105,1,105,1,105,1,105,1,105,1,106,1,106,1,106,1,107,1,107,1,107,
        1,107,1,108,1,108,1,108,1,109,1,109,1,109,1,109,1,110,1,110,1,110,
        1,110,1,110,1,110,1,110,1,110,1,110,1,110,1,110,1,111,1,111,1,111,
        1,111,1,111,1,111,1,112,1,112,1,112,1,112,1,112,1,112,1,112,1,112,
        1,112,1,112,1,112,1,112,1,112,1,113,1,113,1,113,1,113,1,113,1,113,
        1,113,1,113,1,113,1,113,1,113,1,114,1,114,1,114,1,114,1,114,1,114,
        1,115,1,115,1,116,1,116,1,116,1,116,1,116,1,117,1,117,1,117,1,117,
        1,117,1,117,1,118,1,118,1,118,1,118,1,118,1,118,1,118,1,119,1,119,
        1,119,1,119,1,119,1,119,1,120,1,120,1,120,1,120,1,120,1,120,1,120,
        1,120,1,120,1,120,1,120,1,120,1,120,1,120,1,120,1,120,1,121,1,121,
        1,121,1,121,1,121,1,121,1,121,1,121,1,121,1,121,1,121,1,121,1,121,
        1,121,1,121,1,121,1,122,1,122,1,122,1,122,1,122,1,122,1,122,1,122,
        1,122,1,122,1,122,1,122,1,122,1,122,1,123,1,123,1,123,1,123,1,123,
        1,123,1,123,1,123,1,123,1,123,1,123,1,123,1,123,1,124,1,124,1,124,
        1,124,1,124,1,124,1,124,1,124,1,124,1,124,1,124,1,124,1,124,1,124,
        1,124,1,125,1,125,1,126,4,126,1358,8,126,11,126,12,126,1359,1,126,
        1,126,1,127,1,127,1,127,1,127,1,127,1,127,1,127,1,127,1,127,1,127,
        1,128,1,128,1,128,1,128,1,128,1,128,1,128,1,128,1,128,1,128,1,128,
        1,128,1,128,1,128,1,128,1,128,1,128,1,128,1,128,1,128,1,128,1,129,
        1,129,1,129,1,129,1,129,1,129,1,129,1,129,1,129,1,129,1,129,1,129,
        1,129,1,129,1,130,1,130,1,130,1,130,1,130,1,130,1,130,1,130,1,130,
        1,130,1,130,1,130,1,131,1,131,1,131,1,131,1,131,1,131,1,131,1,131,
        1,131,1,131,1,131,1,131,1,132,1,132,1,132,1,132,1,132,1,132,1,132,
        1,133,1,133,1,133,1,133,1,133,1,133,1,133,1,133,1,133,1,133,1,133,
        1,133,1,133,1,133,1,133,1,133,1,133,1,133,1,133,1,133,1,133,1,134,
        1,134,1,134,1,134,1,134,1,134,1,134,1,134,1,134,1,135,1,135,1,135,
        1,135,1,135,1,135,1,135,1,135,1,135,1,135,1,135,1,135,1,135,1,135,
        1,135,1,135,1,135,1,136,1,136,1,136,1,136,1,136,1,136,1,136,1,136,
        1,136,1,136,1,136,1,136,1,136,1,136,1,136,1,136,1,136,1,136,1,136,
        1,136,1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,
        1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,
        1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,138,
        1,138,1,138,1,138,1,138,1,138,1,138,1,138,1,138,1,138,1,138,1,138,
        1,138,1,138,1,138,1,138,1,138,1,138,1,138,1,138,1,138,1,138,1,138,
        1,138,1,139,1,139,1,139,1,139,1,139,1,139,1,139,1,139,1,139,1,139,
        1,139,1,139,1,139,1,139,1,139,1,139,1,139,1,139,1,139,1,139,1,139,
        1,139,1,140,1,140,1,140,1,140,1,140,1,140,1,140,1,140,1,140,1,140,
        1,140,1,140,1,140,1,140,1,140,1,140,1,140,1,140,1,140,1,140,1,140,
        1,140,1,141,1,141,1,141,1,141,1,141,1,141,1,141,1,141,1,141,1,141,
        1,141,1,141,1,141,1,141,1,141,1,141,1,141,1,142,1,142,1,142,1,142,
        1,142,1,142,1,142,1,142,1,142,1,142,1,142,1,142,1,142,1,142,1,142,
        1,142,1,142,1,142,1,142,1,142,1,142,1,142,1,142,1,142,1,142,1,142,
        1,142,1,142,1,142,1,142,1,142,1,143,1,143,1,143,1,143,1,143,1,143,
        1,143,1,143,1,143,1,143,1,143,1,143,1,143,1,143,1,143,1,143,1,143,
        1,143,1,143,1,144,1,144,1,144,1,144,1,144,1,144,1,144,1,144,1,144,
        1,144,1,144,1,144,1,144,1,144,1,144,1,144,1,144,1,144,1,144,1,144,
        1,144,1,144,1,144,1,144,1,144,1,144,1,144,1,145,1,145,1,145,1,145,
        1,145,1,145,1,145,1,145,1,145,1,145,1,145,1,145,1,145,1,145,1,145,
        1,145,1,145,1,145,1,145,1,145,1,145,1,145,1,145,1,145,1,145,1,145,
        1,145,1,146,1,146,1,146,1,146,1,146,1,146,1,146,1,146,1,146,1,146,
        1,146,1,146,1,146,1,146,1,146,1,146,1,146,1,146,1,146,1,146,1,146,
        1,146,1,146,1,146,1,146,1,146,1,146,1,146,1,146,1,146,1,146,1,146,
        1,146,1,146,1,146,1,146,1,146,1,146,1,147,1,147,1,147,1,147,1,147,
        1,147,1,147,1,147,1,147,1,147,1,147,1,147,1,147,1,147,1,147,1,147,
        1,147,1,147,1,147,1,147,1,147,1,147,1,147,1,147,1,147,1,147,1,147,
        1,147,1,147,1,147,1,147,1,148,1,148,1,148,1,148,1,148,1,148,1,148,
        1,148,1,148,1,148,1,148,1,148,1,148,1,148,1,148,1,148,1,148,1,148,
        1,148,1,148,1,148,1,148,1,148,1,148,1,148,1,148,1,148,1,148,1,148,
        1,149,1,149,1,149,1,149,1,149,1,149,1,149,1,149,1,149,1,149,1,149,
        1,149,1,149,1,149,1,149,1,149,1,149,1,149,1,149,1,149,1,149,1,149,
        1,149,1,149,1,149,1,149,1,149,1,149,1,149,1,150,1,150,1,150,1,150,
        1,150,1,150,1,150,1,150,1,150,1,150,1,150,1,150,1,150,1,150,1,150,
        1,150,1,150,1,150,1,150,1,150,1,150,1,150,1,150,1,150,1,151,1,151,
        1,151,1,151,1,151,1,151,1,151,1,151,1,151,1,151,1,151,1,151,1,151,
        1,151,1,151,1,151,1,151,1,151,1,151,1,151,1,151,1,151,1,151,1,151,
        1,151,1,151,1,151,1,151,1,151,1,151,1,151,1,151,1,151,1,151,1,151,
        1,151,1,151,1,151,1,152,1,152,1,152,1,152,1,152,1,152,1,152,1,152,
        1,152,1,152,1,152,1,152,1,152,1,152,1,152,1,152,1,152,1,152,1,152,
        1,152,1,152,1,152,1,152,1,152,1,152,1,152,1,153,1,153,1,153,1,153,
        1,153,1,153,1,153,1,153,1,153,1,153,1,153,1,153,1,153,1,153,1,153,
        1,153,1,153,1,153,1,153,1,153,1,153,1,153,1,153,1,153,1,153,1,153,
        1,153,1,153,1,153,1,153,1,153,1,153,1,153,1,153,1,154,1,154,1,154,
        1,154,1,154,1,154,1,154,1,154,1,154,1,154,1,154,1,154,1,154,1,154,
        1,154,1,154,1,154,1,154,1,154,1,154,1,154,1,154,1,154,1,154,1,154,
        1,154,1,154,1,154,1,154,1,154,1,154,1,154,1,154,1,154,1,154,1,154,
        1,154,1,154,3,154,2014,8,154,1,155,1,155,1,155,1,155,1,155,1,155,
        1,155,1,155,1,155,1,155,1,155,1,155,1,155,1,155,1,155,1,155,1,155,
        1,155,1,155,1,155,1,155,1,155,1,155,1,155,1,155,1,155,1,155,1,155,
        1,155,1,155,1,155,1,155,1,155,1,155,1,155,1,155,1,155,1,155,1,155,
        1,155,1,155,1,155,1,155,1,155,1,155,1,155,3,155,2062,8,155,1,156,
        1,156,1,156,1,156,1,156,1,156,1,156,1,156,1,156,1,156,1,156,1,156,
        1,156,1,156,1,156,1,156,1,156,1,157,1,157,1,157,1,157,1,157,1,157,
        1,157,1,157,1,157,1,157,1,157,1,157,1,157,1,157,1,157,1,157,1,157,
        1,158,1,158,1,158,1,158,1,158,1,158,1,158,1,158,1,158,1,158,1,158,
        1,158,1,158,1,158,1,158,1,159,1,159,1,159,1,159,1,159,1,159,1,159,
        1,159,1,159,1,159,1,159,1,159,1,159,1,159,1,159,1,159,1,159,1,159,
        1,159,1,159,1,159,1,159,1,159,1,159,1,159,1,159,1,159,1,159,1,159,
        1,159,3,159,2143,8,159,1,160,1,160,1,160,1,160,1,160,1,160,1,160,
        1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,160,1,161,1,161,1,161,
        1,161,1,161,1,161,1,161,1,161,1,161,1,161,1,161,1,161,1,161,1,161,
        1,161,1,161,1,161,1,161,3,161,2178,8,161,1,162,1,162,1,162,1,162,
        1,162,1,162,1,162,1,162,1,162,1,162,1,162,1,162,1,162,1,162,1,162,
        1,162,1,162,1,162,1,162,3,162,2199,8,162,1,163,1,163,1,163,1,163,
        1,163,1,163,1,163,1,163,1,163,1,163,1,163,1,163,1,163,1,163,1,163,
        1,163,1,163,1,163,1,163,1,163,1,163,1,163,1,163,1,163,1,163,1,163,
        1,163,1,163,1,163,1,163,1,163,1,163,1,163,1,163,1,163,1,163,1,163,
        1,163,1,163,1,163,1,163,1,163,1,163,1,163,1,163,1,163,1,163,1,163,
        1,163,1,163,1,163,3,163,2252,8,163,1,164,1,164,1,164,1,164,1,164,
        1,164,1,164,1,164,1,164,1,164,1,164,1,164,1,164,1,164,1,164,1,164,
        1,165,1,165,1,165,1,165,1,165,1,165,1,165,1,165,1,165,1,166,1,166,
        1,166,1,166,1,166,1,166,1,166,1,166,1,166,1,166,1,166,1,166,1,166,
        1,166,1,166,1,166,1,166,1,166,1,166,1,166,1,166,1,166,1,166,1,166,
        1,166,1,166,1,166,1,166,1,166,1,166,1,166,1,166,1,166,1,166,1,166,
        1,166,1,166,1,166,1,166,1,166,1,166,1,166,1,166,1,166,1,166,1,166,
        1,166,1,166,1,166,1,166,1,166,1,166,1,166,1,166,1,166,1,166,1,166,
        1,166,1,166,1,166,1,166,1,166,1,166,1,166,1,166,1,166,1,166,1,166,
        1,166,1,166,1,166,1,166,1,166,1,166,1,166,1,166,1,166,1,166,1,166,
        1,166,1,166,1,166,1,166,1,166,1,166,1,166,1,166,3,166,2366,8,166,
        1,167,1,167,1,167,1,167,1,167,1,167,1,167,1,167,1,167,1,167,1,167,
        1,167,1,167,1,167,1,167,1,167,1,167,1,167,1,167,1,167,1,167,1,167,
        1,167,1,167,1,167,1,167,1,167,1,167,1,167,1,167,1,167,1,167,1,167,
        1,167,1,167,1,167,1,167,1,167,1,167,1,167,1,167,1,167,1,167,1,167,
        1,167,1,167,1,167,1,167,1,167,1,167,1,167,1,167,1,167,1,167,1,167,
        1,167,1,167,1,167,1,167,1,167,1,167,3,167,2429,8,167,1,168,1,168,
        1,168,1,168,1,168,1,168,1,168,1,168,1,168,1,168,1,168,1,168,1,168,
        1,168,1,168,1,168,1,168,1,168,1,168,1,168,1,168,1,168,1,168,1,168,
        1,168,1,168,1,168,1,168,1,168,1,168,1,168,1,168,1,168,1,168,1,168,
        1,168,1,168,1,168,1,168,1,168,1,168,1,168,1,168,1,168,1,168,1,168,
        1,168,1,168,1,168,1,168,1,168,1,168,1,168,1,168,1,168,1,168,1,168,
        1,168,1,168,1,168,1,168,1,168,1,168,1,168,1,168,1,168,1,168,1,168,
        1,168,1,168,1,168,1,168,1,168,1,168,1,168,1,168,1,168,1,168,1,168,
        1,168,1,168,1,168,1,168,1,168,1,168,1,168,1,168,1,168,3,168,2519,
        8,168,1,169,1,169,1,169,1,169,1,169,1,169,1,169,1,169,1,169,1,169,
        1,169,1,169,1,169,1,169,1,169,1,169,1,169,1,169,1,169,1,169,1,169,
        1,169,1,169,1,169,1,169,1,169,1,169,1,169,1,169,1,169,1,169,1,169,
        1,169,1,169,1,169,1,169,1,169,1,169,1,169,1,169,1,169,1,169,1,169,
        3,169,2564,8,169,1,170,1,170,1,170,1,170,1,170,1,170,1,170,1,170,
        1,170,1,170,1,170,1,170,1,170,1,170,1,170,1,170,1,170,1,170,1,170,
        1,170,1,170,1,170,1,170,1,170,1,170,1,170,1,170,1,170,1,170,1,170,
        1,170,1,170,1,170,1,170,1,170,1,170,1,170,1,170,1,170,1,170,1,170,
        1,170,1,170,3,170,2609,8,170,1,171,1,171,1,171,1,171,1,171,1,171,
        1,171,1,171,1,171,1,171,1,171,1,171,1,171,1,171,1,171,1,171,1,171,
        1,171,1,171,1,171,1,171,1,171,1,171,1,171,1,171,1,171,1,171,1,171,
        1,171,1,171,1,171,1,171,1,171,1,171,1,171,1,171,1,171,1,171,1,171,
        1,171,1,171,1,171,1,171,1,171,1,171,1,171,1,171,1,171,1,171,1,171,
        1,171,1,171,1,171,1,171,1,171,3,171,2666,8,171,1,172,1,172,1,172,
        1,172,1,172,1,172,1,172,1,172,1,172,1,172,1,172,1,172,1,172,1,172,
        1,172,1,172,1,172,1,172,1,173,1,173,1,173,1,173,1,173,1,173,1,173,
        1,173,1,173,1,173,1,173,1,173,1,173,1,173,1,173,1,173,1,173,1,173,
        1,173,1,173,1,173,1,173,1,173,1,173,1,173,1,173,1,173,1,173,1,173,
        1,173,1,173,1,173,1,173,1,173,1,173,1,173,1,173,1,173,1,173,1,173,
        1,173,1,173,1,173,1,173,1,173,1,173,1,173,1,173,1,173,1,173,1,173,
        3,173,2737,8,173,1,174,1,174,1,174,1,174,1,174,1,174,1,174,1,174,
        1,174,1,174,1,174,1,174,1,174,1,174,1,174,1,174,1,174,1,174,1,174,
        1,174,1,174,1,174,1,174,1,174,1,174,1,174,1,174,1,174,3,174,2767,
        8,174,1,175,1,175,1,175,1,175,1,175,1,175,1,175,1,175,1,175,1,175,
        1,175,1,175,1,175,1,175,1,175,1,175,1,175,1,175,1,175,1,175,1,175,
        1,175,1,175,1,175,1,175,1,176,1,176,1,176,1,176,1,176,1,176,1,176,
        1,176,1,176,1,176,1,176,1,176,1,176,1,176,1,176,1,176,1,177,1,177,
        1,177,1,177,1,177,1,177,1,177,1,177,1,177,1,177,1,177,1,177,1,177,
        1,177,1,177,1,177,1,177,1,177,1,177,1,177,1,178,1,178,1,178,1,178,
        1,178,1,178,1,178,1,178,1,178,1,178,1,178,1,178,1,178,1,178,1,178,
        1,178,1,178,1,178,1,178,1,178,1,178,1,178,1,178,1,178,1,178,1,178,
        1,178,1,178,1,178,1,178,1,178,1,178,1,178,1,178,1,178,1,178,1,178,
        1,178,1,178,1,178,1,178,1,178,1,178,1,178,1,178,1,178,1,178,1,178,
        1,178,1,178,1,178,1,178,1,178,1,178,1,178,1,178,1,178,1,178,1,178,
        1,178,1,178,1,178,1,178,1,178,1,178,3,178,2895,8,178,1,179,1,179,
        1,179,1,179,1,179,1,179,1,179,1,179,1,179,1,179,1,179,1,179,1,179,
        1,179,1,179,1,179,1,179,1,179,1,179,1,179,1,179,1,179,1,179,1,179,
        1,179,1,179,1,179,1,179,1,179,1,179,1,179,1,179,1,179,1,179,1,179,
        1,179,1,179,1,179,1,179,1,179,1,179,1,179,1,179,1,179,1,179,1,179,
        1,179,1,179,1,179,1,179,1,179,1,179,1,179,1,179,1,179,1,179,1,179,
        1,179,1,179,1,179,1,179,1,179,1,179,1,179,1,179,1,179,1,179,1,179,
        1,179,1,179,1,179,1,179,1,179,1,179,1,179,1,179,1,179,1,179,1,179,
        1,179,1,179,1,179,1,179,3,179,2980,8,179,1,180,1,180,1,180,1,180,
        1,180,1,180,1,180,1,180,1,180,1,180,1,180,1,180,1,180,1,180,1,180,
        1,180,1,180,1,180,1,180,1,180,1,180,1,180,1,180,1,180,1,180,1,180,
        1,180,1,180,1,180,1,180,1,180,1,180,1,180,1,180,1,180,1,180,1,180,
        1,180,1,180,1,180,1,180,1,180,1,180,1,180,1,180,1,180,1,180,1,180,
        1,180,1,180,1,180,1,180,1,180,1,180,1,180,1,180,1,180,1,180,1,180,
        1,180,1,180,1,180,1,180,1,180,1,180,1,180,1,180,1,180,1,180,1,180,
        1,180,1,180,1,180,1,180,1,180,1,180,1,180,1,180,1,180,1,180,1,180,
        1,180,1,180,1,180,1,180,1,180,1,180,1,180,1,180,1,180,1,180,1,180,
        1,180,1,180,1,180,3,180,3077,8,180,1,181,1,181,1,181,1,181,1,181,
        1,181,1,181,1,181,1,181,1,181,1,181,1,181,1,181,1,181,1,181,1,181,
        1,181,1,181,1,181,1,181,1,181,1,181,1,181,1,181,1,181,1,181,1,181,
        1,181,1,181,1,181,1,181,1,181,1,181,1,181,1,181,1,181,1,181,1,181,
        1,181,1,181,1,181,1,181,1,181,1,181,1,181,1,181,1,181,1,181,1,181,
        1,181,1,181,1,181,1,181,1,181,1,181,1,181,1,181,1,181,1,181,1,181,
        1,181,1,181,1,181,1,181,1,181,1,181,1,181,1,181,1,181,1,181,1,181,
        1,181,1,181,1,181,1,181,3,181,3154,8,181,1,182,1,182,1,183,1,183,
        1,183,1,183,1,183,1,183,1,183,1,183,1,183,1,183,1,183,1,183,1,183,
        1,183,1,183,1,183,1,183,1,183,1,183,1,183,1,183,1,183,1,183,1,183,
        1,183,1,183,1,183,1,183,1,183,1,183,1,183,1,183,1,183,1,183,1,183,
        1,183,1,183,1,183,1,183,1,183,1,183,1,183,1,183,1,183,1,183,1,183,
        1,183,1,183,1,183,1,183,1,183,1,183,1,183,1,183,1,183,1,183,1,183,
        1,183,1,183,3,183,3217,8,183,1,184,1,184,1,184,1,184,1,184,1,184,
        1,184,1,184,1,184,1,184,1,184,1,184,1,184,1,184,1,184,1,184,1,184,
        1,184,1,184,1,184,1,184,1,184,1,184,1,184,1,184,1,184,1,184,1,184,
        1,184,1,184,1,184,1,184,1,184,1,184,1,184,1,184,1,184,1,184,1,184,
        1,184,1,184,1,184,1,184,3,184,3262,8,184,1,185,1,185,1,185,1,185,
        1,185,1,185,1,185,1,185,1,185,1,185,1,185,1,185,1,185,1,185,1,185,
        1,185,1,185,1,185,1,185,1,185,1,185,1,185,1,185,1,185,1,185,1,185,
        1,185,1,185,1,185,1,185,1,185,1,185,1,185,1,185,1,185,1,185,1,185,
        1,185,1,185,1,185,1,185,1,185,1,185,1,185,1,185,1,185,1,185,1,185,
        1,185,1,185,1,185,1,185,1,185,1,185,1,185,1,185,1,185,1,185,1,185,
        1,185,1,185,1,185,1,185,3,185,3327,8,185,1,186,1,186,1,186,1,186,
        1,186,1,186,1,186,1,186,1,186,1,186,1,186,1,186,1,186,1,186,1,186,
        1,186,1,186,1,186,1,186,1,186,1,186,1,186,1,186,1,186,1,186,1,186,
        1,186,1,186,1,186,1,186,1,186,1,186,1,186,1,186,1,186,1,186,1,186,
        1,186,1,186,1,186,1,186,1,186,1,186,1,186,1,186,1,186,1,186,1,186,
        1,186,1,186,1,186,1,186,1,186,1,186,1,186,1,186,1,186,1,186,1,186,
        1,186,1,186,1,186,1,186,1,186,1,186,1,186,1,186,1,186,1,186,1,186,
        3,186,3399,8,186,0,0,187,1,1,3,2,5,3,7,4,9,5,11,6,13,7,15,8,17,9,
        19,10,21,11,23,12,25,13,27,14,29,15,31,16,33,17,35,18,37,19,39,20,
        41,21,43,22,45,23,47,24,49,25,51,26,53,27,55,28,57,29,59,30,61,31,
        63,32,65,33,67,34,69,35,71,36,73,37,75,38,77,39,79,40,81,41,83,42,
        85,43,87,44,89,45,91,46,93,47,95,48,97,49,99,50,101,51,103,52,105,
        53,107,54,109,55,111,56,113,57,115,58,117,59,119,60,121,61,123,62,
        125,63,127,64,129,65,131,66,133,67,135,68,137,69,139,70,141,71,143,
        72,145,73,147,74,149,75,151,76,153,77,155,78,157,79,159,80,161,81,
        163,82,165,83,167,84,169,0,171,0,173,0,175,0,177,0,179,85,181,86,
        183,87,185,88,187,89,189,90,191,91,193,92,195,93,197,94,199,95,201,
        96,203,97,205,98,207,99,209,100,211,101,213,102,215,103,217,104,
        219,105,221,106,223,107,225,108,227,109,229,110,231,111,233,112,
        235,113,237,114,239,115,241,116,243,117,245,118,247,119,249,120,
        251,121,253,122,255,123,257,124,259,125,261,126,263,127,265,128,
        267,129,269,130,271,131,273,132,275,133,277,134,279,135,281,136,
        283,137,285,138,287,139,289,140,291,141,293,142,295,143,297,144,
        299,145,301,146,303,147,305,148,307,149,309,150,311,151,313,152,
        315,153,317,154,319,155,321,156,323,157,325,158,327,159,329,160,
        331,161,333,162,335,163,337,164,339,165,341,166,343,167,345,168,
        347,169,349,170,351,171,353,172,355,173,357,174,359,175,361,176,
        363,177,365,178,367,179,369,180,371,181,373,182,1,0,15,4,0,46,46,
        48,57,65,90,97,122,4,0,45,45,48,57,65,90,97,122,2,0,10,10,13,13,
        1,0,48,57,1,0,48,48,1,0,49,57,1,0,49,49,1,0,48,50,2,0,44,44,49,50,
        1,0,51,51,2,0,44,44,48,49,2,0,65,90,97,122,2,0,45,46,95,95,8,0,32,
        33,35,44,46,47,58,64,91,94,96,96,123,126,8217,8217,3,0,9,10,13,13,
        32,32,3464,0,1,1,0,0,0,0,3,1,0,0,0,0,5,1,0,0,0,0,7,1,0,0,0,0,9,1,
        0,0,0,0,11,1,0,0,0,0,13,1,0,0,0,0,15,1,0,0,0,0,17,1,0,0,0,0,19,1,
        0,0,0,0,21,1,0,0,0,0,23,1,0,0,0,0,25,1,0,0,0,0,27,1,0,0,0,0,29,1,
        0,0,0,0,31,1,0,0,0,0,33,1,0,0,0,0,35,1,0,0,0,0,37,1,0,0,0,0,39,1,
        0,0,0,0,41,1,0,0,0,0,43,1,0,0,0,0,45,1,0,0,0,0,47,1,0,0,0,0,49,1,
        0,0,0,0,51,1,0,0,0,0,53,1,0,0,0,0,55,1,0,0,0,0,57,1,0,0,0,0,59,1,
        0,0,0,0,61,1,0,0,0,0,63,1,0,0,0,0,65,1,0,0,0,0,67,1,0,0,0,0,69,1,
        0,0,0,0,71,1,0,0,0,0,73,1,0,0,0,0,75,1,0,0,0,0,77,1,0,0,0,0,79,1,
        0,0,0,0,81,1,0,0,0,0,83,1,0,0,0,0,85,1,0,0,0,0,87,1,0,0,0,0,89,1,
        0,0,0,0,91,1,0,0,0,0,93,1,0,0,0,0,95,1,0,0,0,0,97,1,0,0,0,0,99,1,
        0,0,0,0,101,1,0,0,0,0,103,1,0,0,0,0,105,1,0,0,0,0,107,1,0,0,0,0,
        109,1,0,0,0,0,111,1,0,0,0,0,113,1,0,0,0,0,115,1,0,0,0,0,117,1,0,
        0,0,0,119,1,0,0,0,0,121,1,0,0,0,0,123,1,0,0,0,0,125,1,0,0,0,0,127,
        1,0,0,0,0,129,1,0,0,0,0,131,1,0,0,0,0,133,1,0,0,0,0,135,1,0,0,0,
        0,137,1,0,0,0,0,139,1,0,0,0,0,141,1,0,0,0,0,143,1,0,0,0,0,145,1,
        0,0,0,0,147,1,0,0,0,0,149,1,0,0,0,0,151,1,0,0,0,0,153,1,0,0,0,0,
        155,1,0,0,0,0,157,1,0,0,0,0,159,1,0,0,0,0,161,1,0,0,0,0,163,1,0,
        0,0,0,165,1,0,0,0,0,167,1,0,0,0,0,179,1,0,0,0,0,181,1,0,0,0,0,183,
        1,0,0,0,0,185,1,0,0,0,0,187,1,0,0,0,0,189,1,0,0,0,0,191,1,0,0,0,
        0,193,1,0,0,0,0,195,1,0,0,0,0,197,1,0,0,0,0,199,1,0,0,0,0,201,1,
        0,0,0,0,203,1,0,0,0,0,205,1,0,0,0,0,207,1,0,0,0,0,209,1,0,0,0,0,
        211,1,0,0,0,0,213,1,0,0,0,0,215,1,0,0,0,0,217,1,0,0,0,0,219,1,0,
        0,0,0,221,1,0,0,0,0,223,1,0,0,0,0,225,1,0,0,0,0,227,1,0,0,0,0,229,
        1,0,0,0,0,231,1,0,0,0,0,233,1,0,0,0,0,235,1,0,0,0,0,237,1,0,0,0,
        0,239,1,0,0,0,0,241,1,0,0,0,0,243,1,0,0,0,0,245,1,0,0,0,0,247,1,
        0,0,0,0,249,1,0,0,0,0,251,1,0,0,0,0,253,1,0,0,0,0,255,1,0,0,0,0,
        257,1,0,0,0,0,259,1,0,0,0,0,261,1,0,0,0,0,263,1,0,0,0,0,265,1,0,
        0,0,0,267,1,0,0,0,0,269,1,0,0,0,0,271,1,0,0,0,0,273,1,0,0,0,0,275,
        1,0,0,0,0,277,1,0,0,0,0,279,1,0,0,0,0,281,1,0,0,0,0,283,1,0,0,0,
        0,285,1,0,0,0,0,287,1,0,0,0,0,289,1,0,0,0,0,291,1,0,0,0,0,293,1,
        0,0,0,0,295,1,0,0,0,0,297,1,0,0,0,0,299,1,0,0,0,0,301,1,0,0,0,0,
        303,1,0,0,0,0,305,1,0,0,0,0,307,1,0,0,0,0,309,1,0,0,0,0,311,1,0,
        0,0,0,313,1,0,0,0,0,315,1,0,0,0,0,317,1,0,0,0,0,319,1,0,0,0,0,321,
        1,0,0,0,0,323,1,0,0,0,0,325,1,0,0,0,0,327,1,0,0,0,0,329,1,0,0,0,
        0,331,1,0,0,0,0,333,1,0,0,0,0,335,1,0,0,0,0,337,1,0,0,0,0,339,1,
        0,0,0,0,341,1,0,0,0,0,343,1,0,0,0,0,345,1,0,0,0,0,347,1,0,0,0,0,
        349,1,0,0,0,0,351,1,0,0,0,0,353,1,0,0,0,0,355,1,0,0,0,0,357,1,0,
        0,0,0,359,1,0,0,0,0,361,1,0,0,0,0,363,1,0,0,0,0,365,1,0,0,0,0,367,
        1,0,0,0,0,369,1,0,0,0,0,371,1,0,0,0,0,373,1,0,0,0,1,375,1,0,0,0,
        3,386,1,0,0,0,5,392,1,0,0,0,7,406,1,0,0,0,9,423,1,0,0,0,11,440,1,
        0,0,0,13,459,1,0,0,0,15,471,1,0,0,0,17,481,1,0,0,0,19,497,1,0,0,
        0,21,499,1,0,0,0,23,502,1,0,0,0,25,522,1,0,0,0,27,533,1,0,0,0,29,
        535,1,0,0,0,31,550,1,0,0,0,33,555,1,0,0,0,35,557,1,0,0,0,37,572,
        1,0,0,0,39,577,1,0,0,0,41,579,1,0,0,0,43,593,1,0,0,0,45,598,1,0,
        0,0,47,600,1,0,0,0,49,618,1,0,0,0,51,623,1,0,0,0,53,625,1,0,0,0,
        55,647,1,0,0,0,57,650,1,0,0,0,59,654,1,0,0,0,61,658,1,0,0,0,63,662,
        1,0,0,0,65,666,1,0,0,0,67,670,1,0,0,0,69,674,1,0,0,0,71,678,1,0,
        0,0,73,682,1,0,0,0,75,689,1,0,0,0,77,694,1,0,0,0,79,698,1,0,0,0,
        81,702,1,0,0,0,83,706,1,0,0,0,85,710,1,0,0,0,87,714,1,0,0,0,89,718,
        1,0,0,0,91,722,1,0,0,0,93,729,1,0,0,0,95,734,1,0,0,0,97,751,1,0,
        0,0,99,755,1,0,0,0,101,759,1,0,0,0,103,763,1,0,0,0,105,767,1,0,0,
        0,107,771,1,0,0,0,109,775,1,0,0,0,111,779,1,0,0,0,113,783,1,0,0,
        0,115,787,1,0,0,0,117,791,1,0,0,0,119,795,1,0,0,0,121,799,1,0,0,
        0,123,803,1,0,0,0,125,806,1,0,0,0,127,825,1,0,0,0,129,835,1,0,0,
        0,131,858,1,0,0,0,133,883,1,0,0,0,135,908,1,0,0,0,137,938,1,0,0,
        0,139,970,1,0,0,0,141,1002,1,0,0,0,143,1015,1,0,0,0,145,1030,1,0,
        0,0,147,1045,1,0,0,0,149,1059,1,0,0,0,151,1071,1,0,0,0,153,1079,
        1,0,0,0,155,1087,1,0,0,0,157,1089,1,0,0,0,159,1094,1,0,0,0,161,1100,
        1,0,0,0,163,1102,1,0,0,0,165,1104,1,0,0,0,167,1106,1,0,0,0,169,1108,
        1,0,0,0,171,1118,1,0,0,0,173,1122,1,0,0,0,175,1124,1,0,0,0,177,1126,
        1,0,0,0,179,1128,1,0,0,0,181,1130,1,0,0,0,183,1132,1,0,0,0,185,1134,
        1,0,0,0,187,1136,1,0,0,0,189,1138,1,0,0,0,191,1147,1,0,0,0,193,1150,
        1,0,0,0,195,1153,1,0,0,0,197,1156,1,0,0,0,199,1158,1,0,0,0,201,1160,
        1,0,0,0,203,1164,1,0,0,0,205,1168,1,0,0,0,207,1172,1,0,0,0,209,1178,
        1,0,0,0,211,1184,1,0,0,0,213,1193,1,0,0,0,215,1196,1,0,0,0,217,1200,
        1,0,0,0,219,1203,1,0,0,0,221,1207,1,0,0,0,223,1218,1,0,0,0,225,1224,
        1,0,0,0,227,1237,1,0,0,0,229,1248,1,0,0,0,231,1254,1,0,0,0,233,1256,
        1,0,0,0,235,1261,1,0,0,0,237,1267,1,0,0,0,239,1274,1,0,0,0,241,1280,
        1,0,0,0,243,1296,1,0,0,0,245,1312,1,0,0,0,247,1326,1,0,0,0,249,1339,
        1,0,0,0,251,1354,1,0,0,0,253,1357,1,0,0,0,255,1363,1,0,0,0,257,1373,
        1,0,0,0,259,1394,1,0,0,0,261,1408,1,0,0,0,263,1420,1,0,0,0,265,1432,
        1,0,0,0,267,1439,1,0,0,0,269,1460,1,0,0,0,271,1469,1,0,0,0,273,1486,
        1,0,0,0,275,1506,1,0,0,0,277,1537,1,0,0,0,279,1561,1,0,0,0,281,1583,
        1,0,0,0,283,1605,1,0,0,0,285,1622,1,0,0,0,287,1653,1,0,0,0,289,1672,
        1,0,0,0,291,1699,1,0,0,0,293,1726,1,0,0,0,295,1764,1,0,0,0,297,1795,
        1,0,0,0,299,1824,1,0,0,0,301,1853,1,0,0,0,303,1877,1,0,0,0,305,1915,
        1,0,0,0,307,1941,1,0,0,0,309,2013,1,0,0,0,311,2061,1,0,0,0,313,2063,
        1,0,0,0,315,2080,1,0,0,0,317,2097,1,0,0,0,319,2142,1,0,0,0,321,2144,
        1,0,0,0,323,2177,1,0,0,0,325,2198,1,0,0,0,327,2251,1,0,0,0,329,2253,
        1,0,0,0,331,2269,1,0,0,0,333,2365,1,0,0,0,335,2428,1,0,0,0,337,2518,
        1,0,0,0,339,2563,1,0,0,0,341,2608,1,0,0,0,343,2665,1,0,0,0,345,2667,
        1,0,0,0,347,2736,1,0,0,0,349,2766,1,0,0,0,351,2768,1,0,0,0,353,2793,
        1,0,0,0,355,2809,1,0,0,0,357,2894,1,0,0,0,359,2979,1,0,0,0,361,3076,
        1,0,0,0,363,3153,1,0,0,0,365,3155,1,0,0,0,367,3216,1,0,0,0,369,3261,
        1,0,0,0,371,3326,1,0,0,0,373,3398,1,0,0,0,375,376,5,73,0,0,376,377,
        5,78,0,0,377,378,5,68,0,0,378,379,5,69,0,0,379,380,5,88,0,0,380,
        381,5,95,0,0,381,382,5,68,0,0,382,383,5,65,0,0,383,384,5,84,0,0,
        384,385,5,69,0,0,385,2,1,0,0,0,386,387,5,69,0,0,387,388,5,86,0,0,
        388,389,5,69,0,0,389,390,5,78,0,0,390,391,5,84,0,0,391,4,1,0,0,0,
        392,393,5,67,0,0,393,394,5,65,0,0,394,395,5,76,0,0,395,396,5,69,
        0,0,396,397,5,78,0,0,397,398,5,68,0,0,398,399,5,65,0,0,399,400,5,
        82,0,0,400,401,5,95,0,0,401,402,5,68,0,0,402,403,5,65,0,0,403,404,
        5,84,0,0,404,405,5,69,0,0,405,6,1,0,0,0,406,407,5,85,0,0,407,408,
        5,80,0,0,408,409,5,80,0,0,409,410,5,69,0,0,410,411,5,82,0,0,411,
        412,5,95,0,0,412,413,5,68,0,0,413,414,5,65,0,0,414,415,5,84,0,0,
        415,416,5,69,0,0,416,417,5,95,0,0,417,418,5,66,0,0,418,419,5,79,
        0,0,419,420,5,85,0,0,420,421,5,78,0,0,421,422,5,68,0,0,422,8,1,0,
        0,0,423,424,5,76,0,0,424,425,5,79,0,0,425,426,5,87,0,0,426,427,5,
        69,0,0,427,428,5,82,0,0,428,429,5,95,0,0,429,430,5,68,0,0,430,431,
        5,65,0,0,431,432,5,84,0,0,432,433,5,69,0,0,433,434,5,95,0,0,434,
        435,5,66,0,0,435,436,5,79,0,0,436,437,5,85,0,0,437,438,5,78,0,0,
        438,439,5,68,0,0,439,10,1,0,0,0,440,441,5,100,0,0,441,442,5,101,
        0,0,442,443,5,114,0,0,443,444,5,105,0,0,444,445,5,118,0,0,445,446,
        5,101,0,0,446,447,5,100,0,0,447,448,5,95,0,0,448,449,5,101,0,0,449,
        450,5,118,0,0,450,451,5,101,0,0,451,452,5,110,0,0,452,453,5,116,
        0,0,453,454,5,95,0,0,454,455,5,100,0,0,455,456,5,97,0,0,456,457,
        5,116,0,0,457,458,5,101,0,0,458,12,1,0,0,0,459,460,5,67,0,0,460,
        461,5,79,0,0,461,462,5,78,0,0,462,463,5,83,0,0,463,464,5,84,0,0,
        464,465,5,82,0,0,465,466,5,65,0,0,466,467,5,73,0,0,467,468,5,78,
        0,0,468,469,5,84,0,0,469,470,5,83,0,0,470,14,1,0,0,0,471,472,5,65,
        0,0,472,473,5,78,0,0,473,474,5,89,0,0,474,475,5,95,0,0,475,476,5,
        79,0,0,476,477,5,82,0,0,477,478,5,68,0,0,478,479,5,69,0,0,479,480,
        5,82,0,0,480,16,1,0,0,0,481,482,5,73,0,0,482,483,5,83,0,0,483,484,
        5,95,0,0,484,485,5,69,0,0,485,486,5,86,0,0,486,487,5,69,0,0,487,
        488,5,78,0,0,488,489,5,84,0,0,489,490,5,95,0,0,490,491,5,68,0,0,
        491,492,5,65,0,0,492,493,5,84,0,0,493,494,5,69,0,0,494,18,1,0,0,
        0,495,498,3,21,10,0,496,498,3,23,11,0,497,495,1,0,0,0,497,496,1,
        0,0,0,498,20,1,0,0,0,499,500,5,84,0,0,500,501,5,67,0,0,501,22,1,
        0,0,0,502,503,5,84,0,0,503,504,5,69,0,0,504,505,5,77,0,0,505,506,
        5,80,0,0,506,507,5,79,0,0,507,508,5,82,0,0,508,509,5,65,0,0,509,
        510,5,76,0,0,510,511,5,95,0,0,511,512,5,67,0,0,512,513,5,79,0,0,
        513,514,5,78,0,0,514,515,5,83,0,0,515,516,5,84,0,0,516,517,5,82,
        0,0,517,518,5,65,0,0,518,519,5,73,0,0,519,520,5,78,0,0,520,521,5,
        84,0,0,521,24,1,0,0,0,522,523,5,80,0,0,523,524,5,79,0,0,524,525,
        5,83,0,0,525,526,5,73,0,0,526,527,5,84,0,0,527,528,5,73,0,0,528,
        529,5,79,0,0,529,530,5,78,0,0,530,26,1,0,0,0,531,534,3,29,14,0,532,
        534,3,31,15,0,533,531,1,0,0,0,533,532,1,0,0,0,534,28,1,0,0,0,535,
        536,5,67,0,0,536,537,5,79,0,0,537,538,5,78,0,0,538,539,5,67,0,0,
        539,540,5,69,0,0,540,541,5,80,0,0,541,542,5,84,0,0,542,543,5,95,
        0,0,543,544,5,70,0,0,544,545,5,73,0,0,545,546,5,76,0,0,546,547,5,
        84,0,0,547,548,5,69,0,0,548,549,5,82,0,0,549,30,1,0,0,0,550,551,
        5,67,0,0,551,552,5,70,0,0,552,32,1,0,0,0,553,556,3,35,17,0,554,556,
        3,37,18,0,555,553,1,0,0,0,555,554,1,0,0,0,556,34,1,0,0,0,557,558,
        5,78,0,0,558,559,5,85,0,0,559,560,5,77,0,0,560,561,5,69,0,0,561,
        562,5,82,0,0,562,563,5,73,0,0,563,564,5,67,0,0,564,565,5,95,0,0,
        565,566,5,70,0,0,566,567,5,73,0,0,567,568,5,76,0,0,568,569,5,84,
        0,0,569,570,5,69,0,0,570,571,5,82,0,0,571,36,1,0,0,0,572,573,5,78,
        0,0,573,574,5,70,0,0,574,38,1,0,0,0,575,578,3,41,20,0,576,578,3,
        43,21,0,577,575,1,0,0,0,577,576,1,0,0,0,578,40,1,0,0,0,579,580,5,
        83,0,0,580,581,5,84,0,0,581,582,5,82,0,0,582,583,5,73,0,0,583,584,
        5,78,0,0,584,585,5,71,0,0,585,586,5,95,0,0,586,587,5,70,0,0,587,
        588,5,73,0,0,588,589,5,76,0,0,589,590,5,84,0,0,590,591,5,69,0,0,
        591,592,5,82,0,0,592,42,1,0,0,0,593,594,5,83,0,0,594,595,5,70,0,
        0,595,44,1,0,0,0,596,599,3,47,23,0,597,599,3,49,24,0,598,596,1,0,
        0,0,598,597,1,0,0,0,599,46,1,0,0,0,600,601,5,85,0,0,601,602,5,78,
        0,0,602,603,5,73,0,0,603,604,5,81,0,0,604,605,5,85,0,0,605,606,5,
        69,0,0,606,607,5,78,0,0,607,608,5,69,0,0,608,609,5,83,0,0,609,610,
        5,83,0,0,610,611,5,95,0,0,611,612,5,70,0,0,612,613,5,73,0,0,613,
        614,5,76,0,0,614,615,5,84,0,0,615,616,5,69,0,0,616,617,5,82,0,0,
        617,48,1,0,0,0,618,619,5,85,0,0,619,620,5,70,0,0,620,50,1,0,0,0,
        621,624,3,53,26,0,622,624,3,55,27,0,623,621,1,0,0,0,623,622,1,0,
        0,0,624,52,1,0,0,0,625,626,5,82,0,0,626,627,5,69,0,0,627,628,5,76,
        0,0,628,629,5,65,0,0,629,630,5,84,0,0,630,631,5,69,0,0,631,632,5,
        68,0,0,632,633,5,95,0,0,633,634,5,69,0,0,634,635,5,78,0,0,635,636,
        5,84,0,0,636,637,5,73,0,0,637,638,5,84,0,0,638,639,5,89,0,0,639,
        640,5,95,0,0,640,641,5,70,0,0,641,642,5,73,0,0,642,643,5,76,0,0,
        643,644,5,84,0,0,644,645,5,69,0,0,645,646,5,82,0,0,646,54,1,0,0,
        0,647,648,5,82,0,0,648,649,5,70,0,0,649,56,1,0,0,0,650,651,3,273,
        136,0,651,652,3,123,61,0,652,653,3,169,84,0,653,58,1,0,0,0,654,655,
        3,275,137,0,655,656,3,123,61,0,656,657,3,169,84,0,657,60,1,0,0,0,
        658,659,3,277,138,0,659,660,3,123,61,0,660,661,3,169,84,0,661,62,
        1,0,0,0,662,663,3,279,139,0,663,664,3,123,61,0,664,665,3,169,84,
        0,665,64,1,0,0,0,666,667,3,281,140,0,667,668,3,123,61,0,668,669,
        3,169,84,0,669,66,1,0,0,0,670,671,3,283,141,0,671,672,3,123,61,0,
        672,673,3,169,84,0,673,68,1,0,0,0,674,675,3,285,142,0,675,676,3,
        123,61,0,676,677,3,169,84,0,677,70,1,0,0,0,678,679,3,287,143,0,679,
        680,3,123,61,0,680,681,3,169,84,0,681,72,1,0,0,0,682,683,3,289,144,
        0,683,684,3,123,61,0,684,685,3,169,84,0,685,74,1,0,0,0,686,690,3,
        129,64,0,687,690,3,131,65,0,688,690,3,133,66,0,689,686,1,0,0,0,689,
        687,1,0,0,0,689,688,1,0,0,0,690,691,1,0,0,0,691,692,3,123,61,0,692,
        693,3,169,84,0,693,76,1,0,0,0,694,695,3,291,145,0,695,696,3,123,
        61,0,696,697,3,169,84,0,697,78,1,0,0,0,698,699,3,293,146,0,699,700,
        3,123,61,0,700,701,3,169,84,0,701,80,1,0,0,0,702,703,3,295,147,0,
        703,704,3,123,61,0,704,705,3,169,84,0,705,82,1,0,0,0,706,707,3,297,
        148,0,707,708,3,123,61,0,708,709,3,169,84,0,709,84,1,0,0,0,710,711,
        3,299,149,0,711,712,3,123,61,0,712,713,3,169,84,0,713,86,1,0,0,0,
        714,715,3,303,151,0,715,716,3,123,61,0,716,717,3,169,84,0,717,88,
        1,0,0,0,718,719,3,305,152,0,719,720,3,123,61,0,720,721,3,169,84,
        0,721,90,1,0,0,0,722,723,3,307,153,0,723,724,3,123,61,0,724,725,
        3,169,84,0,725,92,1,0,0,0,726,730,3,135,67,0,727,730,3,137,68,0,
        728,730,3,139,69,0,729,726,1,0,0,0,729,727,1,0,0,0,729,728,1,0,0,
        0,730,731,1,0,0,0,731,732,3,123,61,0,732,733,3,169,84,0,733,94,1,
        0,0,0,734,735,5,67,0,0,735,736,5,79,0,0,736,737,5,78,0,0,737,738,
        5,67,0,0,738,739,5,69,0,0,739,740,5,80,0,0,740,741,5,84,0,0,741,
        742,5,95,0,0,742,743,5,71,0,0,743,744,5,82,0,0,744,745,5,79,0,0,
        745,746,5,85,0,0,746,747,5,80,0,0,747,748,1,0,0,0,748,749,3,123,
        61,0,749,750,3,169,84,0,750,96,1,0,0,0,751,752,3,255,127,0,752,753,
        3,123,61,0,753,754,3,169,84,0,754,98,1,0,0,0,755,756,3,257,128,0,
        756,757,3,123,61,0,757,758,3,169,84,0,758,100,1,0,0,0,759,760,3,
        259,129,0,760,761,3,123,61,0,761,762,3,169,84,0,762,102,1,0,0,0,
        763,764,3,261,130,0,764,765,3,123,61,0,765,766,3,169,84,0,766,104,
        1,0,0,0,767,768,3,263,131,0,768,769,3,123,61,0,769,770,3,169,84,
        0,770,106,1,0,0,0,771,772,3,265,132,0,772,773,3,123,61,0,773,774,
        3,169,84,0,774,108,1,0,0,0,775,776,3,267,133,0,776,777,3,123,61,
        0,777,778,3,169,84,0,778,110,1,0,0,0,779,780,3,269,134,0,780,781,
        3,123,61,0,781,782,3,169,84,0,782,112,1,0,0,0,783,784,3,271,135,
        0,784,785,3,123,61,0,785,786,3,169,84,0,786,114,1,0,0,0,787,788,
        3,141,70,0,788,789,3,123,61,0,789,790,3,169,84,0,790,116,1,0,0,0,
        791,792,3,143,71,0,792,793,3,123,61,0,793,794,3,169,84,0,794,118,
        1,0,0,0,795,796,3,145,72,0,796,797,3,123,61,0,797,798,3,169,84,0,
        798,120,1,0,0,0,799,800,3,125,62,0,800,801,3,123,61,0,801,802,3,
        169,84,0,802,122,1,0,0,0,803,804,5,58,0,0,804,805,5,58,0,0,805,124,
        1,0,0,0,806,807,5,83,0,0,807,808,5,85,0,0,808,809,5,66,0,0,809,810,
        5,74,0,0,810,811,5,69,0,0,811,812,5,67,0,0,812,813,5,84,0,0,813,
        814,5,83,0,0,814,815,5,95,0,0,815,816,5,86,0,0,816,817,5,65,0,0,
        817,818,5,82,0,0,818,819,5,73,0,0,819,820,5,65,0,0,820,821,5,66,
        0,0,821,822,5,76,0,0,822,823,5,69,0,0,823,126,1,0,0,0,824,826,7,
        0,0,0,825,824,1,0,0,0,826,827,1,0,0,0,827,825,1,0,0,0,827,828,1,
        0,0,0,828,829,1,0,0,0,829,831,5,47,0,0,830,832,7,1,0,0,831,830,1,
        0,0,0,832,833,1,0,0,0,833,831,1,0,0,0,833,834,1,0,0,0,834,128,1,
        0,0,0,835,836,5,81,0,0,836,837,5,85,0,0,837,838,5,65,0,0,838,839,
        5,76,0,0,839,840,5,73,0,0,840,841,5,70,0,0,841,842,5,73,0,0,842,
        843,5,69,0,0,843,844,5,68,0,0,844,845,5,95,0,0,845,846,5,77,0,0,
        846,847,5,69,0,0,847,848,5,82,0,0,848,849,5,71,0,0,849,850,5,69,
        0,0,850,851,5,68,0,0,851,852,5,95,0,0,852,853,5,69,0,0,853,854,5,
        86,0,0,854,855,5,69,0,0,855,856,5,78,0,0,856,857,5,84,0,0,857,130,
        1,0,0,0,858,859,5,81,0,0,859,860,5,85,0,0,860,861,5,65,0,0,861,862,
        5,76,0,0,862,863,5,73,0,0,863,864,5,70,0,0,864,865,5,73,0,0,865,
        866,5,69,0,0,866,867,5,68,0,0,867,868,5,95,0,0,868,869,5,83,0,0,
        869,870,5,69,0,0,870,871,5,81,0,0,871,872,5,85,0,0,872,873,5,69,
        0,0,873,874,5,78,0,0,874,875,5,67,0,0,875,876,5,69,0,0,876,877,5,
        95,0,0,877,878,5,69,0,0,878,879,5,86,0,0,879,880,5,69,0,0,880,881,
        5,78,0,0,881,882,5,84,0,0,882,132,1,0,0,0,883,884,5,81,0,0,884,885,
        5,85,0,0,885,886,5,65,0,0,886,887,5,76,0,0,887,888,5,73,0,0,888,
        889,5,70,0,0,889,890,5,73,0,0,890,891,5,69,0,0,891,892,5,68,0,0,
        892,893,5,95,0,0,893,894,5,73,0,0,894,895,5,78,0,0,895,896,5,83,
        0,0,896,897,5,84,0,0,897,898,5,65,0,0,898,899,5,78,0,0,899,900,5,
        67,0,0,900,901,5,69,0,0,901,902,5,95,0,0,902,903,5,69,0,0,903,904,
        5,86,0,0,904,905,5,69,0,0,905,906,5,78,0,0,906,907,5,84,0,0,907,
        134,1,0,0,0,908,909,5,83,0,0,909,910,5,85,0,0,910,911,5,66,0,0,911,
        912,5,74,0,0,912,913,5,69,0,0,913,914,5,67,0,0,914,915,5,84,0,0,
        915,916,5,95,0,0,916,917,5,86,0,0,917,918,5,65,0,0,918,919,5,82,
        0,0,919,920,5,73,0,0,920,921,5,65,0,0,921,922,5,66,0,0,922,923,5,
        76,0,0,923,924,5,69,0,0,924,925,5,95,0,0,925,926,5,77,0,0,926,927,
        5,69,0,0,927,928,5,82,0,0,928,929,5,71,0,0,929,930,5,69,0,0,930,
        931,5,68,0,0,931,932,5,95,0,0,932,933,5,69,0,0,933,934,5,86,0,0,
        934,935,5,69,0,0,935,936,5,78,0,0,936,937,5,84,0,0,937,136,1,0,0,
        0,938,939,5,83,0,0,939,940,5,85,0,0,940,941,5,66,0,0,941,942,5,74,
        0,0,942,943,5,69,0,0,943,944,5,67,0,0,944,945,5,84,0,0,945,946,5,
        95,0,0,946,947,5,86,0,0,947,948,5,65,0,0,948,949,5,82,0,0,949,950,
        5,73,0,0,950,951,5,65,0,0,951,952,5,66,0,0,952,953,5,76,0,0,953,
        954,5,69,0,0,954,955,5,95,0,0,955,956,5,83,0,0,956,957,5,69,0,0,
        957,958,5,81,0,0,958,959,5,85,0,0,959,960,5,69,0,0,960,961,5,78,
        0,0,961,962,5,67,0,0,962,963,5,69,0,0,963,964,5,95,0,0,964,965,5,
        69,0,0,965,966,5,86,0,0,966,967,5,69,0,0,967,968,5,78,0,0,968,969,
        5,84,0,0,969,138,1,0,0,0,970,971,5,83,0,0,971,972,5,85,0,0,972,973,
        5,66,0,0,973,974,5,74,0,0,974,975,5,69,0,0,975,976,5,67,0,0,976,
        977,5,84,0,0,977,978,5,95,0,0,978,979,5,86,0,0,979,980,5,65,0,0,
        980,981,5,82,0,0,981,982,5,73,0,0,982,983,5,65,0,0,983,984,5,66,
        0,0,984,985,5,76,0,0,985,986,5,69,0,0,986,987,5,95,0,0,987,988,5,
        73,0,0,988,989,5,78,0,0,989,990,5,83,0,0,990,991,5,84,0,0,991,992,
        5,65,0,0,992,993,5,78,0,0,993,994,5,67,0,0,994,995,5,69,0,0,995,
        996,5,95,0,0,996,997,5,69,0,0,997,998,5,86,0,0,998,999,5,69,0,0,
        999,1000,5,78,0,0,1000,1001,5,84,0,0,1001,140,1,0,0,0,1002,1003,
        5,77,0,0,1003,1004,5,69,0,0,1004,1005,5,82,0,0,1005,1006,5,71,0,
        0,1006,1007,5,69,0,0,1007,1008,5,68,0,0,1008,1009,5,95,0,0,1009,
        1010,5,69,0,0,1010,1011,5,86,0,0,1011,1012,5,69,0,0,1012,1013,5,
        78,0,0,1013,1014,5,84,0,0,1014,142,1,0,0,0,1015,1016,5,83,0,0,1016,
        1017,5,69,0,0,1017,1018,5,81,0,0,1018,1019,5,85,0,0,1019,1020,5,
        69,0,0,1020,1021,5,78,0,0,1021,1022,5,67,0,0,1022,1023,5,69,0,0,
        1023,1024,5,95,0,0,1024,1025,5,69,0,0,1025,1026,5,86,0,0,1026,1027,
        5,69,0,0,1027,1028,5,78,0,0,1028,1029,5,84,0,0,1029,144,1,0,0,0,
        1030,1031,5,73,0,0,1031,1032,5,78,0,0,1032,1033,5,83,0,0,1033,1034,
        5,84,0,0,1034,1035,5,65,0,0,1035,1036,5,78,0,0,1036,1037,5,67,0,
        0,1037,1038,5,69,0,0,1038,1039,5,95,0,0,1039,1040,5,69,0,0,1040,
        1041,5,86,0,0,1041,1042,5,69,0,0,1042,1043,5,78,0,0,1043,1044,5,
        84,0,0,1044,146,1,0,0,0,1045,1046,5,68,0,0,1046,1047,5,69,0,0,1047,
        1048,5,82,0,0,1048,1049,5,73,0,0,1049,1050,5,86,0,0,1050,1051,5,
        69,0,0,1051,1052,5,68,0,0,1052,1053,5,95,0,0,1053,1054,5,69,0,0,
        1054,1055,5,86,0,0,1055,1056,5,69,0,0,1056,1057,5,78,0,0,1057,1058,
        5,84,0,0,1058,148,1,0,0,0,1059,1060,5,47,0,0,1060,1061,5,47,0,0,
        1061,1065,1,0,0,0,1062,1064,8,2,0,0,1063,1062,1,0,0,0,1064,1067,
        1,0,0,0,1065,1063,1,0,0,0,1065,1066,1,0,0,0,1066,1068,1,0,0,0,1067,
        1065,1,0,0,0,1068,1069,6,74,0,0,1069,150,1,0,0,0,1070,1072,7,3,0,
        0,1071,1070,1,0,0,0,1072,1073,1,0,0,0,1073,1071,1,0,0,0,1073,1074,
        1,0,0,0,1074,152,1,0,0,0,1075,1076,7,4,0,0,1076,1080,7,5,0,0,1077,
        1078,7,6,0,0,1078,1080,7,7,0,0,1079,1075,1,0,0,0,1079,1077,1,0,0,
        0,1080,154,1,0,0,0,1081,1082,7,4,0,0,1082,1088,7,5,0,0,1083,1084,
        7,8,0,0,1084,1088,7,3,0,0,1085,1086,7,9,0,0,1086,1088,7,10,0,0,1087,
        1081,1,0,0,0,1087,1083,1,0,0,0,1087,1085,1,0,0,0,1088,156,1,0,0,
        0,1089,1090,7,8,0,0,1090,1091,7,3,0,0,1091,1092,7,3,0,0,1092,1093,
        7,3,0,0,1093,158,1,0,0,0,1094,1095,3,157,78,0,1095,1096,5,45,0,0,
        1096,1097,3,153,76,0,1097,1098,5,45,0,0,1098,1099,3,155,77,0,1099,
        160,1,0,0,0,1100,1101,5,40,0,0,1101,162,1,0,0,0,1102,1103,5,41,0,
        0,1103,164,1,0,0,0,1104,1105,5,59,0,0,1105,166,1,0,0,0,1106,1107,
        5,44,0,0,1107,168,1,0,0,0,1108,1112,5,34,0,0,1109,1113,3,173,86,
        0,1110,1113,3,175,87,0,1111,1113,3,177,88,0,1112,1109,1,0,0,0,1112,
        1110,1,0,0,0,1112,1111,1,0,0,0,1113,1114,1,0,0,0,1114,1112,1,0,0,
        0,1114,1115,1,0,0,0,1115,1116,1,0,0,0,1116,1117,5,34,0,0,1117,170,
        1,0,0,0,1118,1119,7,11,0,0,1119,172,1,0,0,0,1120,1123,3,171,85,0,
        1121,1123,7,3,0,0,1122,1120,1,0,0,0,1122,1121,1,0,0,0,1123,174,1,
        0,0,0,1124,1125,7,12,0,0,1125,176,1,0,0,0,1126,1127,7,13,0,0,1127,
        178,1,0,0,0,1128,1129,5,61,0,0,1129,180,1,0,0,0,1130,1131,5,42,0,
        0,1131,182,1,0,0,0,1132,1133,5,47,0,0,1133,184,1,0,0,0,1134,1135,
        5,43,0,0,1135,186,1,0,0,0,1136,1137,5,45,0,0,1137,188,1,0,0,0,1138,
        1139,5,67,0,0,1139,1140,5,79,0,0,1140,1141,5,78,0,0,1141,1142,5,
        84,0,0,1142,1143,5,65,0,0,1143,1144,5,73,0,0,1144,1145,5,78,0,0,
        1145,1146,5,83,0,0,1146,190,1,0,0,0,1147,1148,5,33,0,0,1148,1149,
        5,61,0,0,1149,192,1,0,0,0,1150,1151,5,60,0,0,1151,1152,5,61,0,0,
        1152,194,1,0,0,0,1153,1154,5,62,0,0,1154,1155,5,61,0,0,1155,196,
        1,0,0,0,1156,1157,5,60,0,0,1157,198,1,0,0,0,1158,1159,5,62,0,0,1159,
        200,1,0,0,0,1160,1161,5,77,0,0,1161,1162,5,65,0,0,1162,1163,5,88,
        0,0,1163,202,1,0,0,0,1164,1165,5,77,0,0,1165,1166,5,73,0,0,1166,
        1167,5,78,0,0,1167,204,1,0,0,0,1168,1169,5,65,0,0,1169,1170,5,86,
        0,0,1170,1171,5,71,0,0,1171,206,1,0,0,0,1172,1173,5,67,0,0,1173,
        1174,5,79,0,0,1174,1175,5,85,0,0,1175,1176,5,78,0,0,1176,1177,5,
        84,0,0,1177,208,1,0,0,0,1178,1179,5,76,0,0,1179,1180,5,69,0,0,1180,
        1181,5,65,0,0,1181,1182,5,83,0,0,1182,1183,5,84,0,0,1183,210,1,0,
        0,0,1184,1185,5,71,0,0,1185,1186,5,82,0,0,1186,1187,5,69,0,0,1187,
        1188,5,65,0,0,1188,1189,5,84,0,0,1189,1190,5,69,0,0,1190,1191,5,
        83,0,0,1191,1192,5,84,0,0,1192,212,1,0,0,0,1193,1194,5,73,0,0,1194,
        1195,5,78,0,0,1195,214,1,0,0,0,1196,1197,5,65,0,0,1197,1198,5,78,
        0,0,1198,1199,5,68,0,0,1199,216,1,0,0,0,1200,1201,5,79,0,0,1201,
        1202,5,82,0,0,1202,218,1,0,0,0,1203,1204,5,78,0,0,1204,1205,5,79,
        0,0,1205,1206,5,84,0,0,1206,220,1,0,0,0,1207,1208,5,67,0,0,1208,
        1209,5,79,0,0,1209,1210,5,77,0,0,1210,1211,5,80,0,0,1211,1212,5,
        76,0,0,1212,1213,5,69,0,0,1213,1214,5,77,0,0,1214,1215,5,69,0,0,
        1215,1216,5,78,0,0,1216,1217,5,84,0,0,1217,222,1,0,0,0,1218,1219,
        5,85,0,0,1219,1220,5,78,0,0,1220,1221,5,73,0,0,1221,1222,5,79,0,
        0,1222,1223,5,78,0,0,1223,224,1,0,0,0,1224,1225,5,73,0,0,1225,1226,
        5,78,0,0,1226,1227,5,84,0,0,1227,1228,5,69,0,0,1228,1229,5,82,0,
        0,1229,1230,5,83,0,0,1230,1231,5,69,0,0,1231,1232,5,67,0,0,1232,
        1233,5,84,0,0,1233,1234,5,73,0,0,1234,1235,5,79,0,0,1235,1236,5,
        78,0,0,1236,226,1,0,0,0,1237,1238,5,68,0,0,1238,1239,5,73,0,0,1239,
        1240,5,70,0,0,1240,1241,5,70,0,0,1241,1242,5,69,0,0,1242,1243,5,
        82,0,0,1243,1244,5,69,0,0,1244,1245,5,78,0,0,1245,1246,5,67,0,0,
        1246,1247,5,69,0,0,1247,228,1,0,0,0,1248,1249,5,73,0,0,1249,1250,
        5,78,0,0,1250,1251,5,68,0,0,1251,1252,5,69,0,0,1252,1253,5,88,0,
        0,1253,230,1,0,0,0,1254,1255,3,233,116,0,1255,232,1,0,0,0,1256,1257,
        5,68,0,0,1257,1258,5,65,0,0,1258,1259,5,89,0,0,1259,1260,5,83,0,
        0,1260,234,1,0,0,0,1261,1262,5,87,0,0,1262,1263,5,69,0,0,1263,1264,
        5,69,0,0,1264,1265,5,75,0,0,1265,1266,5,83,0,0,1266,236,1,0,0,0,
        1267,1268,5,77,0,0,1268,1269,5,79,0,0,1269,1270,5,78,0,0,1270,1271,
        5,84,0,0,1271,1272,5,72,0,0,1272,1273,5,83,0,0,1273,238,1,0,0,0,
        1274,1275,5,89,0,0,1275,1276,5,69,0,0,1276,1277,5,65,0,0,1277,1278,
        5,82,0,0,1278,1279,5,83,0,0,1279,240,1,0,0,0,1280,1281,5,77,0,0,
        1281,1282,5,73,0,0,1282,1283,5,78,0,0,1283,1284,5,73,0,0,1284,1285,
        5,77,0,0,1285,1286,5,85,0,0,1286,1287,5,77,0,0,1287,1288,5,95,0,
        0,1288,1289,5,66,0,0,1289,1290,5,69,0,0,1290,1291,5,84,0,0,1291,
        1292,5,87,0,0,1292,1293,5,69,0,0,1293,1294,5,69,0,0,1294,1295,5,
        78,0,0,1295,242,1,0,0,0,1296,1297,5,77,0,0,1297,1298,5,65,0,0,1298,
        1299,5,88,0,0,1299,1300,5,73,0,0,1300,1301,5,77,0,0,1301,1302,5,
        85,0,0,1302,1303,5,77,0,0,1303,1304,5,95,0,0,1304,1305,5,66,0,0,
        1305,1306,5,69,0,0,1306,1307,5,84,0,0,1307,1308,5,87,0,0,1308,1309,
        5,69,0,0,1309,1310,5,69,0,0,1310,1311,5,78,0,0,1311,244,1,0,0,0,
        1312,1313,5,84,0,0,1313,1314,5,79,0,0,1314,1315,5,84,0,0,1315,1316,
        5,65,0,0,1316,1317,5,76,0,0,1317,1318,5,95,0,0,1318,1319,5,66,0,
        0,1319,1320,5,69,0,0,1320,1321,5,84,0,0,1321,1322,5,87,0,0,1322,
        1323,5,69,0,0,1323,1324,5,69,0,0,1324,1325,5,78,0,0,1325,246,1,0,
        0,0,1326,1327,5,70,0,0,1327,1328,5,73,0,0,1328,1329,5,88,0,0,1329,
        1330,5,69,0,0,1330,1331,5,68,0,0,1331,1332,5,95,0,0,1332,1333,5,
        87,0,0,1333,1334,5,73,0,0,1334,1335,5,78,0,0,1335,1336,5,68,0,0,
        1336,1337,5,79,0,0,1337,1338,5,87,0,0,1338,248,1,0,0,0,1339,1340,
        5,82,0,0,1340,1341,5,79,0,0,1341,1342,5,76,0,0,1342,1343,5,76,0,
        0,1343,1344,5,73,0,0,1344,1345,5,78,0,0,1345,1346,5,71,0,0,1346,
        1347,5,95,0,0,1347,1348,5,87,0,0,1348,1349,5,73,0,0,1349,1350,5,
        78,0,0,1350,1351,5,68,0,0,1351,1352,5,79,0,0,1352,1353,5,87,0,0,
        1353,250,1,0,0,0,1354,1355,5,46,0,0,1355,252,1,0,0,0,1356,1358,7,
        14,0,0,1357,1356,1,0,0,0,1358,1359,1,0,0,0,1359,1357,1,0,0,0,1359,
        1360,1,0,0,0,1360,1361,1,0,0,0,1361,1362,6,126,0,0,1362,254,1,0,
        0,0,1363,1364,5,67,0,0,1364,1365,5,65,0,0,1365,1366,5,82,0,0,1366,
        1367,5,69,0,0,1367,1368,5,95,0,0,1368,1369,5,83,0,0,1369,1370,5,
        73,0,0,1370,1371,5,84,0,0,1371,1372,5,69,0,0,1372,256,1,0,0,0,1373,
        1374,5,67,0,0,1374,1375,5,79,0,0,1375,1376,5,78,0,0,1376,1377,5,
        68,0,0,1377,1378,5,73,0,0,1378,1379,5,84,0,0,1379,1380,5,73,0,0,
        1380,1381,5,79,0,0,1381,1382,5,78,0,0,1382,1383,5,95,0,0,1383,1384,
        5,79,0,0,1384,1385,5,67,0,0,1385,1386,5,67,0,0,1386,1387,5,85,0,
        0,1387,1388,5,82,0,0,1388,1389,5,82,0,0,1389,1390,5,69,0,0,1390,
        1391,5,78,0,0,1391,1392,5,67,0,0,1392,1393,5,69,0,0,1393,258,1,0,
        0,0,1394,1395,5,68,0,0,1395,1396,5,82,0,0,1396,1397,5,85,0,0,1397,
        1398,5,71,0,0,1398,1399,5,95,0,0,1399,1400,5,69,0,0,1400,1401,5,
        88,0,0,1401,1402,5,80,0,0,1402,1403,5,79,0,0,1403,1404,5,83,0,0,
        1404,1405,5,85,0,0,1405,1406,5,82,0,0,1406,1407,5,69,0,0,1407,260,
        1,0,0,0,1408,1409,5,77,0,0,1409,1410,5,69,0,0,1410,1411,5,65,0,0,
        1411,1412,5,83,0,0,1412,1413,5,85,0,0,1413,1414,5,82,0,0,1414,1415,
        5,69,0,0,1415,1416,5,77,0,0,1416,1417,5,69,0,0,1417,1418,5,78,0,
        0,1418,1419,5,84,0,0,1419,262,1,0,0,0,1420,1421,5,79,0,0,1421,1422,
        5,66,0,0,1422,1423,5,83,0,0,1423,1424,5,69,0,0,1424,1425,5,82,0,
        0,1425,1426,5,86,0,0,1426,1427,5,65,0,0,1427,1428,5,84,0,0,1428,
        1429,5,73,0,0,1429,1430,5,79,0,0,1430,1431,5,78,0,0,1431,264,1,0,
        0,0,1432,1433,5,80,0,0,1433,1434,5,69,0,0,1434,1435,5,82,0,0,1435,
        1436,5,83,0,0,1436,1437,5,79,0,0,1437,1438,5,78,0,0,1438,266,1,0,
        0,0,1439,1440,5,80,0,0,1440,1441,5,82,0,0,1441,1442,5,79,0,0,1442,
        1443,5,67,0,0,1443,1444,5,69,0,0,1444,1445,5,68,0,0,1445,1446,5,
        85,0,0,1446,1447,5,82,0,0,1447,1448,5,69,0,0,1448,1449,5,95,0,0,
        1449,1450,5,79,0,0,1450,1451,5,67,0,0,1451,1452,5,67,0,0,1452,1453,
        5,85,0,0,1453,1454,5,82,0,0,1454,1455,5,82,0,0,1455,1456,5,69,0,
        0,1456,1457,5,78,0,0,1457,1458,5,67,0,0,1458,1459,5,69,0,0,1459,
        268,1,0,0,0,1460,1461,5,80,0,0,1461,1462,5,82,0,0,1462,1463,5,79,
        0,0,1463,1464,5,86,0,0,1464,1465,5,73,0,0,1465,1466,5,68,0,0,1466,
        1467,5,69,0,0,1467,1468,5,82,0,0,1468,270,1,0,0,0,1469,1470,5,86,
        0,0,1470,1471,5,73,0,0,1471,1472,5,83,0,0,1472,1473,5,73,0,0,1473,
        1474,5,84,0,0,1474,1475,5,95,0,0,1475,1476,5,79,0,0,1476,1477,5,
        67,0,0,1477,1478,5,67,0,0,1478,1479,5,85,0,0,1479,1480,5,82,0,0,
        1480,1481,5,82,0,0,1481,1482,5,69,0,0,1482,1483,5,78,0,0,1483,1484,
        5,67,0,0,1484,1485,5,69,0,0,1485,272,1,0,0,0,1486,1487,5,81,0,0,
        1487,1488,5,85,0,0,1488,1489,5,65,0,0,1489,1490,5,76,0,0,1490,1491,
        5,73,0,0,1491,1492,5,70,0,0,1492,1493,5,73,0,0,1493,1494,5,69,0,
        0,1494,1495,5,68,0,0,1495,1496,5,95,0,0,1496,1497,5,67,0,0,1497,
        1498,5,65,0,0,1498,1499,5,82,0,0,1499,1500,5,69,0,0,1500,1501,5,
        95,0,0,1501,1502,5,83,0,0,1502,1503,5,73,0,0,1503,1504,5,84,0,0,
        1504,1505,5,69,0,0,1505,274,1,0,0,0,1506,1507,5,81,0,0,1507,1508,
        5,85,0,0,1508,1509,5,65,0,0,1509,1510,5,76,0,0,1510,1511,5,73,0,
        0,1511,1512,5,70,0,0,1512,1513,5,73,0,0,1513,1514,5,69,0,0,1514,
        1515,5,68,0,0,1515,1516,5,95,0,0,1516,1517,5,67,0,0,1517,1518,5,
        79,0,0,1518,1519,5,78,0,0,1519,1520,5,68,0,0,1520,1521,5,73,0,0,
        1521,1522,5,84,0,0,1522,1523,5,73,0,0,1523,1524,5,79,0,0,1524,1525,
        5,78,0,0,1525,1526,5,95,0,0,1526,1527,5,79,0,0,1527,1528,5,67,0,
        0,1528,1529,5,67,0,0,1529,1530,5,85,0,0,1530,1531,5,82,0,0,1531,
        1532,5,82,0,0,1532,1533,5,69,0,0,1533,1534,5,78,0,0,1534,1535,5,
        67,0,0,1535,1536,5,69,0,0,1536,276,1,0,0,0,1537,1538,5,81,0,0,1538,
        1539,5,85,0,0,1539,1540,5,65,0,0,1540,1541,5,76,0,0,1541,1542,5,
        73,0,0,1542,1543,5,70,0,0,1543,1544,5,73,0,0,1544,1545,5,69,0,0,
        1545,1546,5,68,0,0,1546,1547,5,95,0,0,1547,1548,5,68,0,0,1548,1549,
        5,82,0,0,1549,1550,5,85,0,0,1550,1551,5,71,0,0,1551,1552,5,95,0,
        0,1552,1553,5,69,0,0,1553,1554,5,88,0,0,1554,1555,5,80,0,0,1555,
        1556,5,79,0,0,1556,1557,5,83,0,0,1557,1558,5,85,0,0,1558,1559,5,
        82,0,0,1559,1560,5,69,0,0,1560,278,1,0,0,0,1561,1562,5,81,0,0,1562,
        1563,5,85,0,0,1563,1564,5,65,0,0,1564,1565,5,76,0,0,1565,1566,5,
        73,0,0,1566,1567,5,70,0,0,1567,1568,5,73,0,0,1568,1569,5,69,0,0,
        1569,1570,5,68,0,0,1570,1571,5,95,0,0,1571,1572,5,77,0,0,1572,1573,
        5,69,0,0,1573,1574,5,65,0,0,1574,1575,5,83,0,0,1575,1576,5,85,0,
        0,1576,1577,5,82,0,0,1577,1578,5,69,0,0,1578,1579,5,77,0,0,1579,
        1580,5,69,0,0,1580,1581,5,78,0,0,1581,1582,5,84,0,0,1582,280,1,0,
        0,0,1583,1584,5,81,0,0,1584,1585,5,85,0,0,1585,1586,5,65,0,0,1586,
        1587,5,76,0,0,1587,1588,5,73,0,0,1588,1589,5,70,0,0,1589,1590,5,
        73,0,0,1590,1591,5,69,0,0,1591,1592,5,68,0,0,1592,1593,5,95,0,0,
        1593,1594,5,79,0,0,1594,1595,5,66,0,0,1595,1596,5,83,0,0,1596,1597,
        5,69,0,0,1597,1598,5,82,0,0,1598,1599,5,86,0,0,1599,1600,5,65,0,
        0,1600,1601,5,84,0,0,1601,1602,5,73,0,0,1602,1603,5,79,0,0,1603,
        1604,5,78,0,0,1604,282,1,0,0,0,1605,1606,5,81,0,0,1606,1607,5,85,
        0,0,1607,1608,5,65,0,0,1608,1609,5,76,0,0,1609,1610,5,73,0,0,1610,
        1611,5,70,0,0,1611,1612,5,73,0,0,1612,1613,5,69,0,0,1613,1614,5,
        68,0,0,1614,1615,5,95,0,0,1615,1616,5,80,0,0,1616,1617,5,69,0,0,
        1617,1618,5,82,0,0,1618,1619,5,83,0,0,1619,1620,5,79,0,0,1620,1621,
        5,78,0,0,1621,284,1,0,0,0,1622,1623,5,81,0,0,1623,1624,5,85,0,0,
        1624,1625,5,65,0,0,1625,1626,5,76,0,0,1626,1627,5,73,0,0,1627,1628,
        5,70,0,0,1628,1629,5,73,0,0,1629,1630,5,69,0,0,1630,1631,5,68,0,
        0,1631,1632,5,95,0,0,1632,1633,5,80,0,0,1633,1634,5,82,0,0,1634,
        1635,5,79,0,0,1635,1636,5,67,0,0,1636,1637,5,69,0,0,1637,1638,5,
        68,0,0,1638,1639,5,85,0,0,1639,1640,5,82,0,0,1640,1641,5,69,0,0,
        1641,1642,5,95,0,0,1642,1643,5,79,0,0,1643,1644,5,67,0,0,1644,1645,
        5,67,0,0,1645,1646,5,85,0,0,1646,1647,5,82,0,0,1647,1648,5,82,0,
        0,1648,1649,5,69,0,0,1649,1650,5,78,0,0,1650,1651,5,67,0,0,1651,
        1652,5,69,0,0,1652,286,1,0,0,0,1653,1654,5,81,0,0,1654,1655,5,85,
        0,0,1655,1656,5,65,0,0,1656,1657,5,76,0,0,1657,1658,5,73,0,0,1658,
        1659,5,70,0,0,1659,1660,5,73,0,0,1660,1661,5,69,0,0,1661,1662,5,
        68,0,0,1662,1663,5,95,0,0,1663,1664,5,80,0,0,1664,1665,5,82,0,0,
        1665,1666,5,79,0,0,1666,1667,5,86,0,0,1667,1668,5,73,0,0,1668,1669,
        5,68,0,0,1669,1670,5,69,0,0,1670,1671,5,82,0,0,1671,288,1,0,0,0,
        1672,1673,5,81,0,0,1673,1674,5,85,0,0,1674,1675,5,65,0,0,1675,1676,
        5,76,0,0,1676,1677,5,73,0,0,1677,1678,5,70,0,0,1678,1679,5,73,0,
        0,1679,1680,5,69,0,0,1680,1681,5,68,0,0,1681,1682,5,95,0,0,1682,
        1683,5,86,0,0,1683,1684,5,73,0,0,1684,1685,5,83,0,0,1685,1686,5,
        73,0,0,1686,1687,5,84,0,0,1687,1688,5,95,0,0,1688,1689,5,79,0,0,
        1689,1690,5,67,0,0,1690,1691,5,67,0,0,1691,1692,5,85,0,0,1692,1693,
        5,82,0,0,1693,1694,5,82,0,0,1694,1695,5,69,0,0,1695,1696,5,78,0,
        0,1696,1697,5,67,0,0,1697,1698,5,69,0,0,1698,290,1,0,0,0,1699,1700,
        5,83,0,0,1700,1701,5,85,0,0,1701,1702,5,66,0,0,1702,1703,5,74,0,
        0,1703,1704,5,69,0,0,1704,1705,5,67,0,0,1705,1706,5,84,0,0,1706,
        1707,5,95,0,0,1707,1708,5,86,0,0,1708,1709,5,65,0,0,1709,1710,5,
        82,0,0,1710,1711,5,73,0,0,1711,1712,5,65,0,0,1712,1713,5,66,0,0,
        1713,1714,5,76,0,0,1714,1715,5,69,0,0,1715,1716,5,95,0,0,1716,1717,
        5,67,0,0,1717,1718,5,65,0,0,1718,1719,5,82,0,0,1719,1720,5,69,0,
        0,1720,1721,5,95,0,0,1721,1722,5,83,0,0,1722,1723,5,73,0,0,1723,
        1724,5,84,0,0,1724,1725,5,69,0,0,1725,292,1,0,0,0,1726,1727,5,83,
        0,0,1727,1728,5,85,0,0,1728,1729,5,66,0,0,1729,1730,5,74,0,0,1730,
        1731,5,69,0,0,1731,1732,5,67,0,0,1732,1733,5,84,0,0,1733,1734,5,
        95,0,0,1734,1735,5,86,0,0,1735,1736,5,65,0,0,1736,1737,5,82,0,0,
        1737,1738,5,73,0,0,1738,1739,5,65,0,0,1739,1740,5,66,0,0,1740,1741,
        5,76,0,0,1741,1742,5,69,0,0,1742,1743,5,95,0,0,1743,1744,5,67,0,
        0,1744,1745,5,79,0,0,1745,1746,5,78,0,0,1746,1747,5,68,0,0,1747,
        1748,5,73,0,0,1748,1749,5,84,0,0,1749,1750,5,73,0,0,1750,1751,5,
        79,0,0,1751,1752,5,78,0,0,1752,1753,5,95,0,0,1753,1754,5,79,0,0,
        1754,1755,5,67,0,0,1755,1756,5,67,0,0,1756,1757,5,85,0,0,1757,1758,
        5,82,0,0,1758,1759,5,82,0,0,1759,1760,5,69,0,0,1760,1761,5,78,0,
        0,1761,1762,5,67,0,0,1762,1763,5,69,0,0,1763,294,1,0,0,0,1764,1765,
        5,83,0,0,1765,1766,5,85,0,0,1766,1767,5,66,0,0,1767,1768,5,74,0,
        0,1768,1769,5,69,0,0,1769,1770,5,67,0,0,1770,1771,5,84,0,0,1771,
        1772,5,95,0,0,1772,1773,5,86,0,0,1773,1774,5,65,0,0,1774,1775,5,
        82,0,0,1775,1776,5,73,0,0,1776,1777,5,65,0,0,1777,1778,5,66,0,0,
        1778,1779,5,76,0,0,1779,1780,5,69,0,0,1780,1781,5,95,0,0,1781,1782,
        5,68,0,0,1782,1783,5,82,0,0,1783,1784,5,85,0,0,1784,1785,5,71,0,
        0,1785,1786,5,95,0,0,1786,1787,5,69,0,0,1787,1788,5,88,0,0,1788,
        1789,5,80,0,0,1789,1790,5,79,0,0,1790,1791,5,83,0,0,1791,1792,5,
        85,0,0,1792,1793,5,82,0,0,1793,1794,5,69,0,0,1794,296,1,0,0,0,1795,
        1796,5,83,0,0,1796,1797,5,85,0,0,1797,1798,5,66,0,0,1798,1799,5,
        74,0,0,1799,1800,5,69,0,0,1800,1801,5,67,0,0,1801,1802,5,84,0,0,
        1802,1803,5,95,0,0,1803,1804,5,86,0,0,1804,1805,5,65,0,0,1805,1806,
        5,82,0,0,1806,1807,5,73,0,0,1807,1808,5,65,0,0,1808,1809,5,66,0,
        0,1809,1810,5,76,0,0,1810,1811,5,69,0,0,1811,1812,5,95,0,0,1812,
        1813,5,77,0,0,1813,1814,5,69,0,0,1814,1815,5,65,0,0,1815,1816,5,
        83,0,0,1816,1817,5,85,0,0,1817,1818,5,82,0,0,1818,1819,5,69,0,0,
        1819,1820,5,77,0,0,1820,1821,5,69,0,0,1821,1822,5,78,0,0,1822,1823,
        5,84,0,0,1823,298,1,0,0,0,1824,1825,5,83,0,0,1825,1826,5,85,0,0,
        1826,1827,5,66,0,0,1827,1828,5,74,0,0,1828,1829,5,69,0,0,1829,1830,
        5,67,0,0,1830,1831,5,84,0,0,1831,1832,5,95,0,0,1832,1833,5,86,0,
        0,1833,1834,5,65,0,0,1834,1835,5,82,0,0,1835,1836,5,73,0,0,1836,
        1837,5,65,0,0,1837,1838,5,66,0,0,1838,1839,5,76,0,0,1839,1840,5,
        69,0,0,1840,1841,5,95,0,0,1841,1842,5,79,0,0,1842,1843,5,66,0,0,
        1843,1844,5,83,0,0,1844,1845,5,69,0,0,1845,1846,5,82,0,0,1846,1847,
        5,86,0,0,1847,1848,5,65,0,0,1848,1849,5,84,0,0,1849,1850,5,73,0,
        0,1850,1851,5,79,0,0,1851,1852,5,78,0,0,1852,300,1,0,0,0,1853,1854,
        5,83,0,0,1854,1855,5,85,0,0,1855,1856,5,66,0,0,1856,1857,5,74,0,
        0,1857,1858,5,69,0,0,1858,1859,5,67,0,0,1859,1860,5,84,0,0,1860,
        1861,5,95,0,0,1861,1862,5,86,0,0,1862,1863,5,65,0,0,1863,1864,5,
        82,0,0,1864,1865,5,73,0,0,1865,1866,5,65,0,0,1866,1867,5,66,0,0,
        1867,1868,5,76,0,0,1868,1869,5,69,0,0,1869,1870,5,95,0,0,1870,1871,
        5,80,0,0,1871,1872,5,69,0,0,1872,1873,5,82,0,0,1873,1874,5,83,0,
        0,1874,1875,5,79,0,0,1875,1876,5,78,0,0,1876,302,1,0,0,0,1877,1878,
        5,83,0,0,1878,1879,5,85,0,0,1879,1880,5,66,0,0,1880,1881,5,74,0,
        0,1881,1882,5,69,0,0,1882,1883,5,67,0,0,1883,1884,5,84,0,0,1884,
        1885,5,95,0,0,1885,1886,5,86,0,0,1886,1887,5,65,0,0,1887,1888,5,
        82,0,0,1888,1889,5,73,0,0,1889,1890,5,65,0,0,1890,1891,5,66,0,0,
        1891,1892,5,76,0,0,1892,1893,5,69,0,0,1893,1894,5,95,0,0,1894,1895,
        5,80,0,0,1895,1896,5,82,0,0,1896,1897,5,79,0,0,1897,1898,5,67,0,
        0,1898,1899,5,69,0,0,1899,1900,5,68,0,0,1900,1901,5,85,0,0,1901,
        1902,5,82,0,0,1902,1903,5,69,0,0,1903,1904,5,95,0,0,1904,1905,5,
        79,0,0,1905,1906,5,67,0,0,1906,1907,5,67,0,0,1907,1908,5,85,0,0,
        1908,1909,5,82,0,0,1909,1910,5,82,0,0,1910,1911,5,69,0,0,1911,1912,
        5,78,0,0,1912,1913,5,67,0,0,1913,1914,5,69,0,0,1914,304,1,0,0,0,
        1915,1916,5,83,0,0,1916,1917,5,85,0,0,1917,1918,5,66,0,0,1918,1919,
        5,74,0,0,1919,1920,5,69,0,0,1920,1921,5,67,0,0,1921,1922,5,84,0,
        0,1922,1923,5,95,0,0,1923,1924,5,86,0,0,1924,1925,5,65,0,0,1925,
        1926,5,82,0,0,1926,1927,5,73,0,0,1927,1928,5,65,0,0,1928,1929,5,
        66,0,0,1929,1930,5,76,0,0,1930,1931,5,69,0,0,1931,1932,5,95,0,0,
        1932,1933,5,80,0,0,1933,1934,5,82,0,0,1934,1935,5,79,0,0,1935,1936,
        5,86,0,0,1936,1937,5,73,0,0,1937,1938,5,68,0,0,1938,1939,5,69,0,
        0,1939,1940,5,82,0,0,1940,306,1,0,0,0,1941,1942,5,83,0,0,1942,1943,
        5,85,0,0,1943,1944,5,66,0,0,1944,1945,5,74,0,0,1945,1946,5,69,0,
        0,1946,1947,5,67,0,0,1947,1948,5,84,0,0,1948,1949,5,95,0,0,1949,
        1950,5,86,0,0,1950,1951,5,65,0,0,1951,1952,5,82,0,0,1952,1953,5,
        73,0,0,1953,1954,5,65,0,0,1954,1955,5,66,0,0,1955,1956,5,76,0,0,
        1956,1957,5,69,0,0,1957,1958,5,95,0,0,1958,1959,5,86,0,0,1959,1960,
        5,73,0,0,1960,1961,5,83,0,0,1961,1962,5,73,0,0,1962,1963,5,84,0,
        0,1963,1964,5,95,0,0,1964,1965,5,79,0,0,1965,1966,5,67,0,0,1966,
        1967,5,67,0,0,1967,1968,5,85,0,0,1968,1969,5,82,0,0,1969,1970,5,
        82,0,0,1970,1971,5,69,0,0,1971,1972,5,78,0,0,1972,1973,5,67,0,0,
        1973,1974,5,69,0,0,1974,308,1,0,0,0,1975,1976,5,99,0,0,1976,1977,
        5,111,0,0,1977,1978,5,110,0,0,1978,1979,5,100,0,0,1979,1980,5,105,
        0,0,1980,1981,5,116,0,0,1981,1982,5,105,0,0,1982,1983,5,111,0,0,
        1983,1984,5,110,0,0,1984,1985,5,95,0,0,1985,1986,5,115,0,0,1986,
        1987,5,116,0,0,1987,1988,5,97,0,0,1988,1989,5,114,0,0,1989,1990,
        5,116,0,0,1990,1991,5,95,0,0,1991,1992,5,100,0,0,1992,1993,5,97,
        0,0,1993,1994,5,116,0,0,1994,2014,5,101,0,0,1995,1996,5,99,0,0,1996,
        1997,5,111,0,0,1997,1998,5,110,0,0,1998,1999,5,100,0,0,1999,2000,
        5,105,0,0,2000,2001,5,116,0,0,2001,2002,5,105,0,0,2002,2003,5,111,
        0,0,2003,2004,5,110,0,0,2004,2005,5,95,0,0,2005,2006,5,101,0,0,2006,
        2007,5,110,0,0,2007,2008,5,100,0,0,2008,2009,5,95,0,0,2009,2010,
        5,100,0,0,2010,2011,5,97,0,0,2011,2012,5,116,0,0,2012,2014,5,101,
        0,0,2013,1975,1,0,0,0,2013,1995,1,0,0,0,2014,310,1,0,0,0,2015,2016,
        5,100,0,0,2016,2017,5,114,0,0,2017,2018,5,117,0,0,2018,2019,5,103,
        0,0,2019,2020,5,95,0,0,2020,2021,5,101,0,0,2021,2022,5,120,0,0,2022,
        2023,5,112,0,0,2023,2024,5,111,0,0,2024,2025,5,115,0,0,2025,2026,
        5,117,0,0,2026,2027,5,114,0,0,2027,2028,5,101,0,0,2028,2029,5,95,
        0,0,2029,2030,5,115,0,0,2030,2031,5,116,0,0,2031,2032,5,97,0,0,2032,
        2033,5,114,0,0,2033,2034,5,116,0,0,2034,2035,5,95,0,0,2035,2036,
        5,100,0,0,2036,2037,5,97,0,0,2037,2038,5,116,0,0,2038,2062,5,101,
        0,0,2039,2040,5,100,0,0,2040,2041,5,114,0,0,2041,2042,5,117,0,0,
        2042,2043,5,103,0,0,2043,2044,5,95,0,0,2044,2045,5,101,0,0,2045,
        2046,5,120,0,0,2046,2047,5,112,0,0,2047,2048,5,111,0,0,2048,2049,
        5,115,0,0,2049,2050,5,117,0,0,2050,2051,5,114,0,0,2051,2052,5,101,
        0,0,2052,2053,5,95,0,0,2053,2054,5,101,0,0,2054,2055,5,110,0,0,2055,
        2056,5,100,0,0,2056,2057,5,95,0,0,2057,2058,5,100,0,0,2058,2059,
        5,97,0,0,2059,2060,5,116,0,0,2060,2062,5,101,0,0,2061,2015,1,0,0,
        0,2061,2039,1,0,0,0,2062,312,1,0,0,0,2063,2064,5,109,0,0,2064,2065,
        5,101,0,0,2065,2066,5,97,0,0,2066,2067,5,115,0,0,2067,2068,5,117,
        0,0,2068,2069,5,114,0,0,2069,2070,5,101,0,0,2070,2071,5,109,0,0,
        2071,2072,5,101,0,0,2072,2073,5,110,0,0,2073,2074,5,116,0,0,2074,
        2075,5,95,0,0,2075,2076,5,100,0,0,2076,2077,5,97,0,0,2077,2078,5,
        116,0,0,2078,2079,5,101,0,0,2079,314,1,0,0,0,2080,2081,5,111,0,0,
        2081,2082,5,98,0,0,2082,2083,5,115,0,0,2083,2084,5,101,0,0,2084,
        2085,5,114,0,0,2085,2086,5,118,0,0,2086,2087,5,97,0,0,2087,2088,
        5,116,0,0,2088,2089,5,105,0,0,2089,2090,5,111,0,0,2090,2091,5,110,
        0,0,2091,2092,5,95,0,0,2092,2093,5,100,0,0,2093,2094,5,97,0,0,2094,
        2095,5,116,0,0,2095,2096,5,101,0,0,2096,316,1,0,0,0,2097,2098,5,
        112,0,0,2098,2099,5,114,0,0,2099,2100,5,111,0,0,2100,2101,5,99,0,
        0,2101,2102,5,101,0,0,2102,2103,5,100,0,0,2103,2104,5,117,0,0,2104,
        2105,5,114,0,0,2105,2106,5,101,0,0,2106,2107,5,95,0,0,2107,2108,
        5,100,0,0,2108,2109,5,97,0,0,2109,2110,5,116,0,0,2110,2111,5,101,
        0,0,2111,318,1,0,0,0,2112,2113,5,118,0,0,2113,2114,5,105,0,0,2114,
        2115,5,115,0,0,2115,2116,5,105,0,0,2116,2117,5,116,0,0,2117,2118,
        5,95,0,0,2118,2119,5,115,0,0,2119,2120,5,116,0,0,2120,2121,5,97,
        0,0,2121,2122,5,114,0,0,2122,2123,5,116,0,0,2123,2124,5,95,0,0,2124,
        2125,5,100,0,0,2125,2126,5,97,0,0,2126,2127,5,116,0,0,2127,2143,
        5,101,0,0,2128,2129,5,118,0,0,2129,2130,5,105,0,0,2130,2131,5,115,
        0,0,2131,2132,5,105,0,0,2132,2133,5,116,0,0,2133,2134,5,95,0,0,2134,
        2135,5,101,0,0,2135,2136,5,110,0,0,2136,2137,5,100,0,0,2137,2138,
        5,95,0,0,2138,2139,5,100,0,0,2139,2140,5,97,0,0,2140,2141,5,116,
        0,0,2141,2143,5,101,0,0,2142,2112,1,0,0,0,2142,2128,1,0,0,0,2143,
        320,1,0,0,0,2144,2145,5,98,0,0,2145,2146,5,105,0,0,2146,2147,5,114,
        0,0,2147,2148,5,116,0,0,2148,2149,5,104,0,0,2149,2150,5,95,0,0,2150,
        2151,5,100,0,0,2151,2152,5,97,0,0,2152,2153,5,116,0,0,2153,2154,
        5,101,0,0,2154,2155,5,116,0,0,2155,2156,5,105,0,0,2156,2157,5,109,
        0,0,2157,2158,5,101,0,0,2158,322,1,0,0,0,2159,2160,5,114,0,0,2160,
        2161,5,101,0,0,2161,2162,5,102,0,0,2162,2163,5,105,0,0,2163,2164,
        5,108,0,0,2164,2165,5,108,0,0,2165,2178,5,115,0,0,2166,2167,5,100,
        0,0,2167,2168,5,97,0,0,2168,2169,5,121,0,0,2169,2170,5,115,0,0,2170,
        2171,5,95,0,0,2171,2172,5,115,0,0,2172,2173,5,117,0,0,2173,2174,
        5,112,0,0,2174,2175,5,112,0,0,2175,2176,5,108,0,0,2176,2178,5,121,
        0,0,2177,2159,1,0,0,0,2177,2166,1,0,0,0,2178,324,1,0,0,0,2179,2180,
        5,114,0,0,2180,2181,5,97,0,0,2181,2182,5,110,0,0,2182,2183,5,103,
        0,0,2183,2184,5,101,0,0,2184,2185,5,95,0,0,2185,2186,5,104,0,0,2186,
        2187,5,105,0,0,2187,2188,5,103,0,0,2188,2199,5,104,0,0,2189,2190,
        5,114,0,0,2190,2191,5,97,0,0,2191,2192,5,110,0,0,2192,2193,5,103,
        0,0,2193,2194,5,101,0,0,2194,2195,5,95,0,0,2195,2196,5,108,0,0,2196,
        2197,5,111,0,0,2197,2199,5,119,0,0,2198,2179,1,0,0,0,2198,2189,1,
        0,0,0,2199,326,1,0,0,0,2200,2201,5,121,0,0,2201,2202,5,101,0,0,2202,
        2203,5,97,0,0,2203,2204,5,114,0,0,2204,2205,5,95,0,0,2205,2206,5,
        111,0,0,2206,2207,5,102,0,0,2207,2208,5,95,0,0,2208,2209,5,98,0,
        0,2209,2210,5,105,0,0,2210,2211,5,114,0,0,2211,2212,5,116,0,0,2212,
        2252,5,104,0,0,2213,2214,5,109,0,0,2214,2215,5,111,0,0,2215,2216,
        5,110,0,0,2216,2217,5,116,0,0,2217,2218,5,104,0,0,2218,2219,5,95,
        0,0,2219,2220,5,111,0,0,2220,2221,5,102,0,0,2221,2222,5,95,0,0,2222,
        2223,5,98,0,0,2223,2224,5,105,0,0,2224,2225,5,114,0,0,2225,2226,
        5,116,0,0,2226,2252,5,104,0,0,2227,2228,5,100,0,0,2228,2229,5,97,
        0,0,2229,2230,5,121,0,0,2230,2231,5,95,0,0,2231,2232,5,111,0,0,2232,
        2233,5,102,0,0,2233,2234,5,95,0,0,2234,2235,5,98,0,0,2235,2236,5,
        105,0,0,2236,2237,5,114,0,0,2237,2238,5,116,0,0,2238,2252,5,104,
        0,0,2239,2240,5,65,0,0,2240,2241,5,71,0,0,2241,2242,5,69,0,0,2242,
        2243,5,95,0,0,2243,2244,5,65,0,0,2244,2245,5,84,0,0,2245,2246,5,
        95,0,0,2246,2247,5,73,0,0,2247,2248,5,78,0,0,2248,2249,5,68,0,0,
        2249,2250,5,69,0,0,2250,2252,5,88,0,0,2251,2200,1,0,0,0,2251,2213,
        1,0,0,0,2251,2227,1,0,0,0,2251,2239,1,0,0,0,2252,328,1,0,0,0,2253,
        2254,5,118,0,0,2254,2255,5,97,0,0,2255,2256,5,108,0,0,2256,2257,
        5,117,0,0,2257,2258,5,101,0,0,2258,2259,5,95,0,0,2259,2260,5,97,
        0,0,2260,2261,5,115,0,0,2261,2262,5,95,0,0,2262,2263,5,110,0,0,2263,
        2264,5,117,0,0,2264,2265,5,109,0,0,2265,2266,5,98,0,0,2266,2267,
        5,101,0,0,2267,2268,5,114,0,0,2268,330,1,0,0,0,2269,2270,5,113,0,
        0,2270,2271,5,117,0,0,2271,2272,5,97,0,0,2272,2273,5,110,0,0,2273,
        2274,5,116,0,0,2274,2275,5,105,0,0,2275,2276,5,116,0,0,2276,2277,
        5,121,0,0,2277,332,1,0,0,0,2278,2279,5,99,0,0,2279,2280,5,111,0,
        0,2280,2281,5,110,0,0,2281,2282,5,100,0,0,2282,2283,5,105,0,0,2283,
        2284,5,116,0,0,2284,2285,5,105,0,0,2285,2286,5,111,0,0,2286,2287,
        5,110,0,0,2287,2288,5,95,0,0,2288,2289,5,99,0,0,2289,2290,5,111,
        0,0,2290,2291,5,110,0,0,2291,2292,5,99,0,0,2292,2293,5,101,0,0,2293,
        2294,5,112,0,0,2294,2366,5,116,0,0,2295,2296,5,99,0,0,2296,2297,
        5,111,0,0,2297,2298,5,110,0,0,2298,2299,5,100,0,0,2299,2300,5,105,
        0,0,2300,2301,5,116,0,0,2301,2302,5,105,0,0,2302,2303,5,111,0,0,
        2303,2304,5,110,0,0,2304,2305,5,95,0,0,2305,2306,5,116,0,0,2306,
        2307,5,121,0,0,2307,2308,5,112,0,0,2308,2309,5,101,0,0,2309,2310,
        5,95,0,0,2310,2311,5,99,0,0,2311,2312,5,111,0,0,2312,2313,5,110,
        0,0,2313,2314,5,99,0,0,2314,2315,5,101,0,0,2315,2316,5,112,0,0,2316,
        2366,5,116,0,0,2317,2318,5,99,0,0,2318,2319,5,111,0,0,2319,2320,
        5,110,0,0,2320,2321,5,100,0,0,2321,2322,5,105,0,0,2322,2323,5,116,
        0,0,2323,2324,5,105,0,0,2324,2325,5,111,0,0,2325,2326,5,110,0,0,
        2326,2327,5,95,0,0,2327,2328,5,115,0,0,2328,2329,5,116,0,0,2329,
        2330,5,97,0,0,2330,2331,5,116,0,0,2331,2332,5,117,0,0,2332,2333,
        5,115,0,0,2333,2334,5,95,0,0,2334,2335,5,99,0,0,2335,2336,5,111,
        0,0,2336,2337,5,110,0,0,2337,2338,5,99,0,0,2338,2339,5,101,0,0,2339,
        2340,5,112,0,0,2340,2366,5,116,0,0,2341,2342,5,99,0,0,2342,2343,
        5,111,0,0,2343,2344,5,110,0,0,2344,2345,5,100,0,0,2345,2346,5,105,
        0,0,2346,2347,5,116,0,0,2347,2348,5,105,0,0,2348,2349,5,111,0,0,
        2349,2350,5,110,0,0,2350,2351,5,95,0,0,2351,2352,5,115,0,0,2352,
        2353,5,111,0,0,2353,2354,5,117,0,0,2354,2355,5,114,0,0,2355,2356,
        5,99,0,0,2356,2357,5,101,0,0,2357,2358,5,95,0,0,2358,2359,5,99,0,
        0,2359,2360,5,111,0,0,2360,2361,5,110,0,0,2361,2362,5,99,0,0,2362,
        2363,5,101,0,0,2363,2364,5,112,0,0,2364,2366,5,116,0,0,2365,2278,
        1,0,0,0,2365,2295,1,0,0,0,2365,2317,1,0,0,0,2365,2341,1,0,0,0,2366,
        334,1,0,0,0,2367,2368,5,100,0,0,2368,2369,5,114,0,0,2369,2370,5,
        117,0,0,2370,2371,5,103,0,0,2371,2372,5,95,0,0,2372,2373,5,99,0,
        0,2373,2374,5,111,0,0,2374,2375,5,110,0,0,2375,2376,5,99,0,0,2376,
        2377,5,101,0,0,2377,2378,5,112,0,0,2378,2429,5,116,0,0,2379,2380,
        5,100,0,0,2380,2381,5,114,0,0,2381,2382,5,117,0,0,2382,2383,5,103,
        0,0,2383,2384,5,95,0,0,2384,2385,5,116,0,0,2385,2386,5,121,0,0,2386,
        2387,5,112,0,0,2387,2388,5,101,0,0,2388,2389,5,95,0,0,2389,2390,
        5,99,0,0,2390,2391,5,111,0,0,2391,2392,5,110,0,0,2392,2393,5,99,
        0,0,2393,2394,5,101,0,0,2394,2395,5,112,0,0,2395,2429,5,116,0,0,
        2396,2397,5,114,0,0,2397,2398,5,111,0,0,2398,2399,5,117,0,0,2399,
        2400,5,116,0,0,2400,2401,5,101,0,0,2401,2402,5,95,0,0,2402,2403,
        5,99,0,0,2403,2404,5,111,0,0,2404,2405,5,110,0,0,2405,2406,5,99,
        0,0,2406,2407,5,101,0,0,2407,2408,5,112,0,0,2408,2429,5,116,0,0,
        2409,2410,5,100,0,0,2410,2411,5,114,0,0,2411,2412,5,117,0,0,2412,
        2413,5,103,0,0,2413,2414,5,95,0,0,2414,2415,5,115,0,0,2415,2416,
        5,111,0,0,2416,2417,5,117,0,0,2417,2418,5,114,0,0,2418,2419,5,99,
        0,0,2419,2420,5,101,0,0,2420,2421,5,95,0,0,2421,2422,5,99,0,0,2422,
        2423,5,111,0,0,2423,2424,5,110,0,0,2424,2425,5,99,0,0,2425,2426,
        5,101,0,0,2426,2427,5,112,0,0,2427,2429,5,116,0,0,2428,2367,1,0,
        0,0,2428,2379,1,0,0,0,2428,2396,1,0,0,0,2428,2409,1,0,0,0,2429,336,
        1,0,0,0,2430,2431,5,109,0,0,2431,2432,5,101,0,0,2432,2433,5,97,0,
        0,2433,2434,5,115,0,0,2434,2435,5,117,0,0,2435,2436,5,114,0,0,2436,
        2437,5,101,0,0,2437,2438,5,109,0,0,2438,2439,5,101,0,0,2439,2440,
        5,110,0,0,2440,2441,5,116,0,0,2441,2442,5,95,0,0,2442,2443,5,99,
        0,0,2443,2444,5,111,0,0,2444,2445,5,110,0,0,2445,2446,5,99,0,0,2446,
        2447,5,101,0,0,2447,2448,5,112,0,0,2448,2519,5,116,0,0,2449,2450,
        5,109,0,0,2450,2451,5,101,0,0,2451,2452,5,97,0,0,2452,2453,5,115,
        0,0,2453,2454,5,117,0,0,2454,2455,5,114,0,0,2455,2456,5,101,0,0,
        2456,2457,5,109,0,0,2457,2458,5,101,0,0,2458,2459,5,110,0,0,2459,
        2460,5,116,0,0,2460,2461,5,95,0,0,2461,2462,5,115,0,0,2462,2463,
        5,111,0,0,2463,2464,5,117,0,0,2464,2465,5,114,0,0,2465,2466,5,99,
        0,0,2466,2467,5,101,0,0,2467,2468,5,95,0,0,2468,2469,5,99,0,0,2469,
        2470,5,111,0,0,2470,2471,5,110,0,0,2471,2472,5,99,0,0,2472,2473,
        5,101,0,0,2473,2474,5,112,0,0,2474,2519,5,116,0,0,2475,2476,5,109,
        0,0,2476,2477,5,101,0,0,2477,2478,5,97,0,0,2478,2479,5,115,0,0,2479,
        2480,5,117,0,0,2480,2481,5,114,0,0,2481,2482,5,101,0,0,2482,2483,
        5,109,0,0,2483,2484,5,101,0,0,2484,2485,5,110,0,0,2485,2486,5,116,
        0,0,2486,2487,5,95,0,0,2487,2488,5,116,0,0,2488,2489,5,121,0,0,2489,
        2490,5,112,0,0,2490,2491,5,101,0,0,2491,2492,5,95,0,0,2492,2493,
        5,99,0,0,2493,2494,5,111,0,0,2494,2495,5,110,0,0,2495,2496,5,99,
        0,0,2496,2497,5,101,0,0,2497,2498,5,112,0,0,2498,2519,5,116,0,0,
        2499,2500,5,117,0,0,2500,2501,5,110,0,0,2501,2502,5,105,0,0,2502,
        2503,5,116,0,0,2503,2504,5,95,0,0,2504,2505,5,115,0,0,2505,2506,
        5,111,0,0,2506,2507,5,117,0,0,2507,2508,5,114,0,0,2508,2509,5,99,
        0,0,2509,2510,5,101,0,0,2510,2511,5,95,0,0,2511,2512,5,99,0,0,2512,
        2513,5,111,0,0,2513,2514,5,110,0,0,2514,2515,5,99,0,0,2515,2516,
        5,101,0,0,2516,2517,5,112,0,0,2517,2519,5,116,0,0,2518,2430,1,0,
        0,0,2518,2449,1,0,0,0,2518,2475,1,0,0,0,2518,2499,1,0,0,0,2519,338,
        1,0,0,0,2520,2521,5,111,0,0,2521,2522,5,98,0,0,2522,2523,5,115,0,
        0,2523,2524,5,101,0,0,2524,2525,5,114,0,0,2525,2526,5,118,0,0,2526,
        2527,5,97,0,0,2527,2528,5,116,0,0,2528,2529,5,105,0,0,2529,2530,
        5,111,0,0,2530,2531,5,110,0,0,2531,2532,5,95,0,0,2532,2533,5,99,
        0,0,2533,2534,5,111,0,0,2534,2535,5,110,0,0,2535,2536,5,99,0,0,2536,
        2537,5,101,0,0,2537,2538,5,112,0,0,2538,2564,5,116,0,0,2539,2540,
        5,111,0,0,2540,2541,5,98,0,0,2541,2542,5,115,0,0,2542,2543,5,101,
        0,0,2543,2544,5,114,0,0,2544,2545,5,118,0,0,2545,2546,5,97,0,0,2546,
        2547,5,116,0,0,2547,2548,5,105,0,0,2548,2549,5,111,0,0,2549,2550,
        5,110,0,0,2550,2551,5,95,0,0,2551,2552,5,116,0,0,2552,2553,5,121,
        0,0,2553,2554,5,112,0,0,2554,2555,5,101,0,0,2555,2556,5,95,0,0,2556,
        2557,5,99,0,0,2557,2558,5,111,0,0,2558,2559,5,110,0,0,2559,2560,
        5,99,0,0,2560,2561,5,101,0,0,2561,2562,5,112,0,0,2562,2564,5,116,
        0,0,2563,2520,1,0,0,0,2563,2539,1,0,0,0,2564,340,1,0,0,0,2565,2566,
        5,103,0,0,2566,2567,5,101,0,0,2567,2568,5,110,0,0,2568,2569,5,100,
        0,0,2569,2570,5,101,0,0,2570,2571,5,114,0,0,2571,2572,5,95,0,0,2572,
        2573,5,99,0,0,2573,2574,5,111,0,0,2574,2575,5,110,0,0,2575,2576,
        5,99,0,0,2576,2577,5,101,0,0,2577,2578,5,112,0,0,2578,2609,5,116,
        0,0,2579,2580,5,114,0,0,2580,2581,5,97,0,0,2581,2582,5,99,0,0,2582,
        2583,5,101,0,0,2583,2584,5,95,0,0,2584,2585,5,99,0,0,2585,2586,5,
        111,0,0,2586,2587,5,110,0,0,2587,2588,5,99,0,0,2588,2589,5,101,0,
        0,2589,2590,5,112,0,0,2590,2609,5,116,0,0,2591,2592,5,101,0,0,2592,
        2593,5,116,0,0,2593,2594,5,104,0,0,2594,2595,5,110,0,0,2595,2596,
        5,105,0,0,2596,2597,5,99,0,0,2597,2598,5,105,0,0,2598,2599,5,116,
        0,0,2599,2600,5,121,0,0,2600,2601,5,95,0,0,2601,2602,5,99,0,0,2602,
        2603,5,111,0,0,2603,2604,5,110,0,0,2604,2605,5,99,0,0,2605,2606,
        5,101,0,0,2606,2607,5,112,0,0,2607,2609,5,116,0,0,2608,2565,1,0,
        0,0,2608,2579,1,0,0,0,2608,2591,1,0,0,0,2609,342,1,0,0,0,2610,2611,
        5,112,0,0,2611,2612,5,114,0,0,2612,2613,5,111,0,0,2613,2614,5,99,
        0,0,2614,2615,5,101,0,0,2615,2616,5,100,0,0,2616,2617,5,117,0,0,
        2617,2618,5,114,0,0,2618,2619,5,101,0,0,2619,2620,5,95,0,0,2620,
        2621,5,99,0,0,2621,2622,5,111,0,0,2622,2623,5,110,0,0,2623,2624,
        5,99,0,0,2624,2625,5,101,0,0,2625,2626,5,112,0,0,2626,2666,5,116,
        0,0,2627,2628,5,112,0,0,2628,2629,5,114,0,0,2629,2630,5,111,0,0,
        2630,2631,5,99,0,0,2631,2632,5,101,0,0,2632,2633,5,100,0,0,2633,
        2634,5,117,0,0,2634,2635,5,114,0,0,2635,2636,5,101,0,0,2636,2637,
        5,95,0,0,2637,2638,5,116,0,0,2638,2639,5,121,0,0,2639,2640,5,112,
        0,0,2640,2641,5,101,0,0,2641,2642,5,95,0,0,2642,2643,5,99,0,0,2643,
        2644,5,111,0,0,2644,2645,5,110,0,0,2645,2646,5,99,0,0,2646,2647,
        5,101,0,0,2647,2648,5,112,0,0,2648,2666,5,116,0,0,2649,2650,5,109,
        0,0,2650,2651,5,111,0,0,2651,2652,5,100,0,0,2652,2653,5,105,0,0,
        2653,2654,5,102,0,0,2654,2655,5,105,0,0,2655,2656,5,101,0,0,2656,
        2657,5,114,0,0,2657,2658,5,95,0,0,2658,2659,5,99,0,0,2659,2660,5,
        111,0,0,2660,2661,5,110,0,0,2661,2662,5,99,0,0,2662,2663,5,101,0,
        0,2663,2664,5,112,0,0,2664,2666,5,116,0,0,2665,2610,1,0,0,0,2665,
        2627,1,0,0,0,2665,2649,1,0,0,0,2666,344,1,0,0,0,2667,2668,5,115,
        0,0,2668,2669,5,112,0,0,2669,2670,5,101,0,0,2670,2671,5,99,0,0,2671,
        2672,5,105,0,0,2672,2673,5,97,0,0,2673,2674,5,108,0,0,2674,2675,
        5,116,0,0,2675,2676,5,121,0,0,2676,2677,5,95,0,0,2677,2678,5,99,
        0,0,2678,2679,5,111,0,0,2679,2680,5,110,0,0,2680,2681,5,99,0,0,2681,
        2682,5,101,0,0,2682,2683,5,112,0,0,2683,2684,5,116,0,0,2684,346,
        1,0,0,0,2685,2686,5,118,0,0,2686,2687,5,105,0,0,2687,2688,5,115,
        0,0,2688,2689,5,105,0,0,2689,2690,5,116,0,0,2690,2691,5,95,0,0,2691,
        2692,5,99,0,0,2692,2693,5,111,0,0,2693,2694,5,110,0,0,2694,2695,
        5,99,0,0,2695,2696,5,101,0,0,2696,2697,5,112,0,0,2697,2737,5,116,
        0,0,2698,2699,5,118,0,0,2699,2700,5,105,0,0,2700,2701,5,115,0,0,
        2701,2702,5,105,0,0,2702,2703,5,116,0,0,2703,2704,5,95,0,0,2704,
        2705,5,115,0,0,2705,2706,5,111,0,0,2706,2707,5,117,0,0,2707,2708,
        5,114,0,0,2708,2709,5,99,0,0,2709,2710,5,101,0,0,2710,2711,5,95,
        0,0,2711,2712,5,99,0,0,2712,2713,5,111,0,0,2713,2714,5,110,0,0,2714,
        2715,5,99,0,0,2715,2716,5,101,0,0,2716,2717,5,112,0,0,2717,2737,
        5,116,0,0,2718,2719,5,118,0,0,2719,2720,5,105,0,0,2720,2721,5,115,
        0,0,2721,2722,5,105,0,0,2722,2723,5,116,0,0,2723,2724,5,95,0,0,2724,
        2725,5,116,0,0,2725,2726,5,121,0,0,2726,2727,5,112,0,0,2727,2728,
        5,101,0,0,2728,2729,5,95,0,0,2729,2730,5,99,0,0,2730,2731,5,111,
        0,0,2731,2732,5,110,0,0,2732,2733,5,99,0,0,2733,2734,5,101,0,0,2734,
        2735,5,112,0,0,2735,2737,5,116,0,0,2736,2685,1,0,0,0,2736,2698,1,
        0,0,0,2736,2718,1,0,0,0,2737,348,1,0,0,0,2738,2739,5,118,0,0,2739,
        2740,5,97,0,0,2740,2741,5,108,0,0,2741,2742,5,117,0,0,2742,2743,
        5,101,0,0,2743,2744,5,95,0,0,2744,2745,5,97,0,0,2745,2746,5,115,
        0,0,2746,2747,5,95,0,0,2747,2748,5,99,0,0,2748,2749,5,111,0,0,2749,
        2750,5,110,0,0,2750,2751,5,99,0,0,2751,2752,5,101,0,0,2752,2753,
        5,112,0,0,2753,2767,5,116,0,0,2754,2755,5,117,0,0,2755,2756,5,110,
        0,0,2756,2757,5,105,0,0,2757,2758,5,116,0,0,2758,2759,5,95,0,0,2759,
        2760,5,99,0,0,2760,2761,5,111,0,0,2761,2762,5,110,0,0,2762,2763,
        5,99,0,0,2763,2764,5,101,0,0,2764,2765,5,112,0,0,2765,2767,5,116,
        0,0,2766,2738,1,0,0,0,2766,2754,1,0,0,0,2767,350,1,0,0,0,2768,2769,
        5,112,0,0,2769,2770,5,108,0,0,2770,2771,5,97,0,0,2771,2772,5,99,
        0,0,2772,2773,5,101,0,0,2773,2774,5,95,0,0,2774,2775,5,111,0,0,2775,
        2776,5,102,0,0,2776,2777,5,95,0,0,2777,2778,5,115,0,0,2778,2779,
        5,101,0,0,2779,2780,5,114,0,0,2780,2781,5,118,0,0,2781,2782,5,105,
        0,0,2782,2783,5,99,0,0,2783,2784,5,101,0,0,2784,2785,5,95,0,0,2785,
        2786,5,99,0,0,2786,2787,5,111,0,0,2787,2788,5,110,0,0,2788,2789,
        5,99,0,0,2789,2790,5,101,0,0,2790,2791,5,112,0,0,2791,2792,5,116,
        0,0,2792,352,1,0,0,0,2793,2794,5,118,0,0,2794,2795,5,97,0,0,2795,
        2796,5,108,0,0,2796,2797,5,117,0,0,2797,2798,5,101,0,0,2798,2799,
        5,95,0,0,2799,2800,5,97,0,0,2800,2801,5,115,0,0,2801,2802,5,95,0,
        0,2802,2803,5,115,0,0,2803,2804,5,116,0,0,2804,2805,5,114,0,0,2805,
        2806,5,105,0,0,2806,2807,5,110,0,0,2807,2808,5,103,0,0,2808,354,
        1,0,0,0,2809,2810,5,103,0,0,2810,2811,5,101,0,0,2811,2812,5,110,
        0,0,2812,2813,5,100,0,0,2813,2814,5,101,0,0,2814,2815,5,114,0,0,
        2815,2816,5,95,0,0,2816,2817,5,115,0,0,2817,2818,5,111,0,0,2818,
        2819,5,117,0,0,2819,2820,5,114,0,0,2820,2821,5,99,0,0,2821,2822,
        5,101,0,0,2822,2823,5,95,0,0,2823,2824,5,118,0,0,2824,2825,5,97,
        0,0,2825,2826,5,108,0,0,2826,2827,5,117,0,0,2827,2828,5,101,0,0,
        2828,356,1,0,0,0,2829,2830,5,99,0,0,2830,2831,5,97,0,0,2831,2832,
        5,114,0,0,2832,2833,5,101,0,0,2833,2834,5,95,0,0,2834,2835,5,115,
        0,0,2835,2836,5,105,0,0,2836,2837,5,116,0,0,2837,2838,5,101,0,0,
        2838,2839,5,95,0,0,2839,2840,5,110,0,0,2840,2841,5,97,0,0,2841,2842,
        5,109,0,0,2842,2895,5,101,0,0,2843,2844,5,99,0,0,2844,2845,5,97,
        0,0,2845,2846,5,114,0,0,2846,2847,5,101,0,0,2847,2848,5,95,0,0,2848,
        2849,5,115,0,0,2849,2850,5,105,0,0,2850,2851,5,116,0,0,2851,2852,
        5,101,0,0,2852,2853,5,95,0,0,2853,2854,5,115,0,0,2854,2855,5,111,
        0,0,2855,2856,5,117,0,0,2856,2857,5,114,0,0,2857,2858,5,99,0,0,2858,
        2859,5,101,0,0,2859,2860,5,95,0,0,2860,2861,5,118,0,0,2861,2862,
        5,97,0,0,2862,2863,5,108,0,0,2863,2864,5,117,0,0,2864,2895,5,101,
        0,0,2865,2866,5,112,0,0,2866,2867,5,108,0,0,2867,2868,5,97,0,0,2868,
        2869,5,99,0,0,2869,2870,5,101,0,0,2870,2871,5,95,0,0,2871,2872,5,
        111,0,0,2872,2873,5,102,0,0,2873,2874,5,95,0,0,2874,2875,5,115,0,
        0,2875,2876,5,101,0,0,2876,2877,5,114,0,0,2877,2878,5,118,0,0,2878,
        2879,5,105,0,0,2879,2880,5,99,0,0,2880,2881,5,101,0,0,2881,2882,
        5,95,0,0,2882,2883,5,115,0,0,2883,2884,5,111,0,0,2884,2885,5,117,
        0,0,2885,2886,5,114,0,0,2886,2887,5,99,0,0,2887,2888,5,101,0,0,2888,
        2889,5,95,0,0,2889,2890,5,118,0,0,2890,2891,5,97,0,0,2891,2892,5,
        108,0,0,2892,2893,5,117,0,0,2893,2895,5,101,0,0,2894,2829,1,0,0,
        0,2894,2843,1,0,0,0,2894,2865,1,0,0,0,2895,358,1,0,0,0,2896,2897,
        5,99,0,0,2897,2898,5,111,0,0,2898,2899,5,110,0,0,2899,2900,5,100,
        0,0,2900,2901,5,105,0,0,2901,2902,5,116,0,0,2902,2903,5,105,0,0,
        2903,2904,5,111,0,0,2904,2905,5,110,0,0,2905,2906,5,95,0,0,2906,
        2907,5,111,0,0,2907,2908,5,99,0,0,2908,2909,5,99,0,0,2909,2910,5,
        117,0,0,2910,2911,5,114,0,0,2911,2912,5,114,0,0,2912,2913,5,101,
        0,0,2913,2914,5,110,0,0,2914,2915,5,99,0,0,2915,2916,5,101,0,0,2916,
        2917,5,95,0,0,2917,2918,5,115,0,0,2918,2919,5,116,0,0,2919,2920,
        5,111,0,0,2920,2921,5,112,0,0,2921,2922,5,95,0,0,2922,2923,5,114,
        0,0,2923,2924,5,101,0,0,2924,2925,5,97,0,0,2925,2926,5,115,0,0,2926,
        2927,5,111,0,0,2927,2980,5,110,0,0,2928,2929,5,99,0,0,2929,2930,
        5,111,0,0,2930,2931,5,110,0,0,2931,2932,5,100,0,0,2932,2933,5,105,
        0,0,2933,2934,5,116,0,0,2934,2935,5,105,0,0,2935,2936,5,111,0,0,
        2936,2937,5,110,0,0,2937,2938,5,95,0,0,2938,2939,5,115,0,0,2939,
        2940,5,111,0,0,2940,2941,5,117,0,0,2941,2942,5,114,0,0,2942,2943,
        5,99,0,0,2943,2944,5,101,0,0,2944,2945,5,95,0,0,2945,2946,5,118,
        0,0,2946,2947,5,97,0,0,2947,2948,5,108,0,0,2948,2949,5,117,0,0,2949,
        2980,5,101,0,0,2950,2951,5,99,0,0,2951,2952,5,111,0,0,2952,2953,
        5,110,0,0,2953,2954,5,100,0,0,2954,2955,5,105,0,0,2955,2956,5,116,
        0,0,2956,2957,5,105,0,0,2957,2958,5,111,0,0,2958,2959,5,110,0,0,
        2959,2960,5,95,0,0,2960,2961,5,115,0,0,2961,2962,5,116,0,0,2962,
        2963,5,97,0,0,2963,2964,5,116,0,0,2964,2965,5,117,0,0,2965,2966,
        5,115,0,0,2966,2967,5,95,0,0,2967,2968,5,115,0,0,2968,2969,5,111,
        0,0,2969,2970,5,117,0,0,2970,2971,5,114,0,0,2971,2972,5,99,0,0,2972,
        2973,5,101,0,0,2973,2974,5,95,0,0,2974,2975,5,118,0,0,2975,2976,
        5,97,0,0,2976,2977,5,108,0,0,2977,2978,5,117,0,0,2978,2980,5,101,
        0,0,2979,2896,1,0,0,0,2979,2928,1,0,0,0,2979,2950,1,0,0,0,2980,360,
        1,0,0,0,2981,2982,5,100,0,0,2982,2983,5,114,0,0,2983,2984,5,117,
        0,0,2984,2985,5,103,0,0,2985,2986,5,95,0,0,2986,2987,5,101,0,0,2987,
        2988,5,120,0,0,2988,2989,5,112,0,0,2989,2990,5,111,0,0,2990,2991,
        5,115,0,0,2991,2992,5,117,0,0,2992,2993,5,114,0,0,2993,2994,5,101,
        0,0,2994,2995,5,95,0,0,2995,2996,5,115,0,0,2996,2997,5,116,0,0,2997,
        2998,5,111,0,0,2998,2999,5,112,0,0,2999,3000,5,95,0,0,3000,3001,
        5,114,0,0,3001,3002,5,101,0,0,3002,3003,5,97,0,0,3003,3004,5,115,
        0,0,3004,3005,5,111,0,0,3005,3077,5,110,0,0,3006,3007,5,115,0,0,
        3007,3008,5,105,0,0,3008,3077,5,103,0,0,3009,3010,5,108,0,0,3010,
        3011,5,111,0,0,3011,3012,5,116,0,0,3012,3013,5,95,0,0,3013,3014,
        5,110,0,0,3014,3015,5,117,0,0,3015,3016,5,109,0,0,3016,3017,5,98,
        0,0,3017,3018,5,101,0,0,3018,3077,5,114,0,0,3019,3020,5,100,0,0,
        3020,3021,5,114,0,0,3021,3022,5,117,0,0,3022,3023,5,103,0,0,3023,
        3024,5,95,0,0,3024,3025,5,115,0,0,3025,3026,5,111,0,0,3026,3027,
        5,117,0,0,3027,3028,5,114,0,0,3028,3029,5,99,0,0,3029,3030,5,101,
        0,0,3030,3031,5,95,0,0,3031,3032,5,118,0,0,3032,3033,5,97,0,0,3033,
        3034,5,108,0,0,3034,3035,5,117,0,0,3035,3077,5,101,0,0,3036,3037,
        5,114,0,0,3037,3038,5,111,0,0,3038,3039,5,117,0,0,3039,3040,5,116,
        0,0,3040,3041,5,101,0,0,3041,3042,5,95,0,0,3042,3043,5,115,0,0,3043,
        3044,5,111,0,0,3044,3045,5,117,0,0,3045,3046,5,114,0,0,3046,3047,
        5,99,0,0,3047,3048,5,101,0,0,3048,3049,5,95,0,0,3049,3050,5,118,
        0,0,3050,3051,5,97,0,0,3051,3052,5,108,0,0,3052,3053,5,117,0,0,3053,
        3077,5,101,0,0,3054,3055,5,100,0,0,3055,3056,5,111,0,0,3056,3057,
        5,115,0,0,3057,3058,5,101,0,0,3058,3059,5,95,0,0,3059,3060,5,117,
        0,0,3060,3061,5,110,0,0,3061,3062,5,105,0,0,3062,3063,5,116,0,0,
        3063,3064,5,95,0,0,3064,3065,5,115,0,0,3065,3066,5,111,0,0,3066,
        3067,5,117,0,0,3067,3068,5,114,0,0,3068,3069,5,99,0,0,3069,3070,
        5,101,0,0,3070,3071,5,95,0,0,3071,3072,5,118,0,0,3072,3073,5,97,
        0,0,3073,3074,5,108,0,0,3074,3075,5,117,0,0,3075,3077,5,101,0,0,
        3076,2981,1,0,0,0,3076,3006,1,0,0,0,3076,3009,1,0,0,0,3076,3019,
        1,0,0,0,3076,3036,1,0,0,0,3076,3054,1,0,0,0,3077,362,1,0,0,0,3078,
        3079,5,109,0,0,3079,3080,5,101,0,0,3080,3081,5,97,0,0,3081,3082,
        5,115,0,0,3082,3083,5,117,0,0,3083,3084,5,114,0,0,3084,3085,5,101,
        0,0,3085,3086,5,109,0,0,3086,3087,5,101,0,0,3087,3088,5,110,0,0,
        3088,3089,5,116,0,0,3089,3090,5,95,0,0,3090,3091,5,116,0,0,3091,
        3092,5,105,0,0,3092,3093,5,109,0,0,3093,3154,5,101,0,0,3094,3095,
        5,109,0,0,3095,3096,5,101,0,0,3096,3097,5,97,0,0,3097,3098,5,115,
        0,0,3098,3099,5,117,0,0,3099,3100,5,114,0,0,3100,3101,5,101,0,0,
        3101,3102,5,109,0,0,3102,3103,5,101,0,0,3103,3104,5,110,0,0,3104,
        3105,5,116,0,0,3105,3106,5,95,0,0,3106,3107,5,115,0,0,3107,3108,
        5,111,0,0,3108,3109,5,117,0,0,3109,3110,5,114,0,0,3110,3111,5,99,
        0,0,3111,3112,5,101,0,0,3112,3113,5,95,0,0,3113,3114,5,118,0,0,3114,
        3115,5,97,0,0,3115,3116,5,108,0,0,3116,3117,5,117,0,0,3117,3154,
        5,101,0,0,3118,3119,5,117,0,0,3119,3120,5,110,0,0,3120,3121,5,105,
        0,0,3121,3122,5,116,0,0,3122,3123,5,95,0,0,3123,3124,5,115,0,0,3124,
        3125,5,111,0,0,3125,3126,5,117,0,0,3126,3127,5,114,0,0,3127,3128,
        5,99,0,0,3128,3129,5,101,0,0,3129,3130,5,95,0,0,3130,3131,5,118,
        0,0,3131,3132,5,97,0,0,3132,3133,5,108,0,0,3133,3134,5,117,0,0,3134,
        3154,5,101,0,0,3135,3136,5,118,0,0,3136,3137,5,97,0,0,3137,3138,
        5,108,0,0,3138,3139,5,117,0,0,3139,3140,5,101,0,0,3140,3141,5,95,
        0,0,3141,3142,5,115,0,0,3142,3143,5,111,0,0,3143,3144,5,117,0,0,
        3144,3145,5,114,0,0,3145,3146,5,99,0,0,3146,3147,5,101,0,0,3147,
        3148,5,95,0,0,3148,3149,5,118,0,0,3149,3150,5,97,0,0,3150,3151,5,
        108,0,0,3151,3152,5,117,0,0,3152,3154,5,101,0,0,3153,3078,1,0,0,
        0,3153,3094,1,0,0,0,3153,3118,1,0,0,0,3153,3135,1,0,0,0,3154,364,
        1,0,0,0,3155,3156,3,353,176,0,3156,366,1,0,0,0,3157,3158,5,112,0,
        0,3158,3159,5,101,0,0,3159,3160,5,114,0,0,3160,3161,5,115,0,0,3161,
        3162,5,111,0,0,3162,3163,5,110,0,0,3163,3164,5,95,0,0,3164,3165,
        5,115,0,0,3165,3166,5,111,0,0,3166,3167,5,117,0,0,3167,3168,5,114,
        0,0,3168,3169,5,99,0,0,3169,3170,5,101,0,0,3170,3171,5,95,0,0,3171,
        3172,5,118,0,0,3172,3173,5,97,0,0,3173,3174,5,108,0,0,3174,3175,
        5,117,0,0,3175,3217,5,101,0,0,3176,3217,3,355,177,0,3177,3178,5,
        114,0,0,3178,3179,5,97,0,0,3179,3180,5,99,0,0,3180,3181,5,101,0,
        0,3181,3182,5,95,0,0,3182,3183,5,115,0,0,3183,3184,5,111,0,0,3184,
        3185,5,117,0,0,3185,3186,5,114,0,0,3186,3187,5,99,0,0,3187,3188,
        5,101,0,0,3188,3189,5,95,0,0,3189,3190,5,118,0,0,3190,3191,5,97,
        0,0,3191,3192,5,108,0,0,3192,3193,5,117,0,0,3193,3217,5,101,0,0,
        3194,3195,5,101,0,0,3195,3196,5,116,0,0,3196,3197,5,104,0,0,3197,
        3198,5,110,0,0,3198,3199,5,105,0,0,3199,3200,5,99,0,0,3200,3201,
        5,105,0,0,3201,3202,5,116,0,0,3202,3203,5,121,0,0,3203,3204,5,95,
        0,0,3204,3205,5,115,0,0,3205,3206,5,111,0,0,3206,3207,5,117,0,0,
        3207,3208,5,114,0,0,3208,3209,5,99,0,0,3209,3210,5,101,0,0,3210,
        3211,5,95,0,0,3211,3212,5,118,0,0,3212,3213,5,97,0,0,3213,3214,5,
        108,0,0,3214,3215,5,117,0,0,3215,3217,5,101,0,0,3216,3157,1,0,0,
        0,3216,3176,1,0,0,0,3216,3177,1,0,0,0,3216,3194,1,0,0,0,3217,368,
        1,0,0,0,3218,3219,5,112,0,0,3219,3220,5,114,0,0,3220,3221,5,111,
        0,0,3221,3222,5,99,0,0,3222,3223,5,101,0,0,3223,3224,5,100,0,0,3224,
        3225,5,117,0,0,3225,3226,5,114,0,0,3226,3227,5,101,0,0,3227,3228,
        5,95,0,0,3228,3229,5,115,0,0,3229,3230,5,111,0,0,3230,3231,5,117,
        0,0,3231,3232,5,114,0,0,3232,3233,5,99,0,0,3233,3234,5,101,0,0,3234,
        3235,5,95,0,0,3235,3236,5,118,0,0,3236,3237,5,97,0,0,3237,3238,5,
        108,0,0,3238,3239,5,117,0,0,3239,3262,5,101,0,0,3240,3241,5,109,
        0,0,3241,3242,5,111,0,0,3242,3243,5,100,0,0,3243,3244,5,105,0,0,
        3244,3245,5,102,0,0,3245,3246,5,105,0,0,3246,3247,5,101,0,0,3247,
        3248,5,114,0,0,3248,3249,5,95,0,0,3249,3250,5,115,0,0,3250,3251,
        5,111,0,0,3251,3252,5,117,0,0,3252,3253,5,114,0,0,3253,3254,5,99,
        0,0,3254,3255,5,101,0,0,3255,3256,5,95,0,0,3256,3257,5,118,0,0,3257,
        3258,5,97,0,0,3258,3259,5,108,0,0,3259,3260,5,117,0,0,3260,3262,
        5,101,0,0,3261,3218,1,0,0,0,3261,3240,1,0,0,0,3262,370,1,0,0,0,3263,
        3264,5,112,0,0,3264,3265,5,114,0,0,3265,3266,5,111,0,0,3266,3267,
        5,118,0,0,3267,3268,5,105,0,0,3268,3269,5,100,0,0,3269,3270,5,101,
        0,0,3270,3271,5,114,0,0,3271,3272,5,95,0,0,3272,3273,5,110,0,0,3273,
        3274,5,97,0,0,3274,3275,5,109,0,0,3275,3327,5,101,0,0,3276,3277,
        5,110,0,0,3277,3278,5,112,0,0,3278,3327,5,105,0,0,3279,3280,5,100,
        0,0,3280,3281,5,101,0,0,3281,3327,5,97,0,0,3282,3283,5,112,0,0,3283,
        3284,5,114,0,0,3284,3285,5,111,0,0,3285,3286,5,118,0,0,3286,3287,
        5,105,0,0,3287,3288,5,100,0,0,3288,3289,5,101,0,0,3289,3290,5,114,
        0,0,3290,3291,5,95,0,0,3291,3292,5,115,0,0,3292,3293,5,111,0,0,3293,
        3294,5,117,0,0,3294,3295,5,114,0,0,3295,3296,5,99,0,0,3296,3297,
        5,101,0,0,3297,3298,5,95,0,0,3298,3299,5,118,0,0,3299,3300,5,97,
        0,0,3300,3301,5,108,0,0,3301,3302,5,117,0,0,3302,3327,5,101,0,0,
        3303,3304,5,115,0,0,3304,3305,5,112,0,0,3305,3306,5,101,0,0,3306,
        3307,5,99,0,0,3307,3308,5,105,0,0,3308,3309,5,97,0,0,3309,3310,5,
        108,0,0,3310,3311,5,116,0,0,3311,3312,5,121,0,0,3312,3313,5,95,0,
        0,3313,3314,5,115,0,0,3314,3315,5,111,0,0,3315,3316,5,117,0,0,3316,
        3317,5,114,0,0,3317,3318,5,99,0,0,3318,3319,5,101,0,0,3319,3320,
        5,95,0,0,3320,3321,5,118,0,0,3321,3322,5,97,0,0,3322,3323,5,108,
        0,0,3323,3324,5,117,0,0,3324,3327,5,101,0,0,3325,3327,3,355,177,
        0,3326,3263,1,0,0,0,3326,3276,1,0,0,0,3326,3279,1,0,0,0,3326,3282,
        1,0,0,0,3326,3303,1,0,0,0,3326,3325,1,0,0,0,3327,372,1,0,0,0,3328,
        3329,5,118,0,0,3329,3330,5,105,0,0,3330,3331,5,115,0,0,3331,3332,
        5,105,0,0,3332,3333,5,116,0,0,3333,3334,5,95,0,0,3334,3335,5,115,
        0,0,3335,3336,5,111,0,0,3336,3337,5,117,0,0,3337,3338,5,114,0,0,
        3338,3339,5,99,0,0,3339,3340,5,101,0,0,3340,3341,5,95,0,0,3341,3342,
        5,118,0,0,3342,3343,5,97,0,0,3343,3344,5,108,0,0,3344,3345,5,117,
        0,0,3345,3399,5,101,0,0,3346,3347,5,97,0,0,3347,3348,5,100,0,0,3348,
        3349,5,109,0,0,3349,3350,5,105,0,0,3350,3351,5,116,0,0,3351,3352,
        5,116,0,0,3352,3353,5,101,0,0,3353,3354,5,100,0,0,3354,3355,5,95,
        0,0,3355,3356,5,102,0,0,3356,3357,5,114,0,0,3357,3358,5,111,0,0,
        3358,3359,5,109,0,0,3359,3360,5,95,0,0,3360,3361,5,115,0,0,3361,
        3362,5,111,0,0,3362,3363,5,117,0,0,3363,3364,5,114,0,0,3364,3365,
        5,99,0,0,3365,3366,5,101,0,0,3366,3367,5,95,0,0,3367,3368,5,118,
        0,0,3368,3369,5,97,0,0,3369,3370,5,108,0,0,3370,3371,5,117,0,0,3371,
        3399,5,101,0,0,3372,3373,5,100,0,0,3373,3374,5,105,0,0,3374,3375,
        5,115,0,0,3375,3376,5,99,0,0,3376,3377,5,104,0,0,3377,3378,5,97,
        0,0,3378,3379,5,114,0,0,3379,3380,5,103,0,0,3380,3381,5,101,0,0,
        3381,3382,5,100,0,0,3382,3383,5,95,0,0,3383,3384,5,116,0,0,3384,
        3385,5,111,0,0,3385,3386,5,95,0,0,3386,3387,5,115,0,0,3387,3388,
        5,111,0,0,3388,3389,5,117,0,0,3389,3390,5,114,0,0,3390,3391,5,99,
        0,0,3391,3392,5,101,0,0,3392,3393,5,95,0,0,3393,3394,5,118,0,0,3394,
        3395,5,97,0,0,3395,3396,5,108,0,0,3396,3397,5,117,0,0,3397,3399,
        5,101,0,0,3398,3328,1,0,0,0,3398,3346,1,0,0,0,3398,3372,1,0,0,0,
        3399,374,1,0,0,0,41,0,497,533,555,577,598,623,689,729,827,833,1065,
        1073,1079,1087,1112,1114,1122,1359,2013,2061,2142,2177,2198,2251,
        2365,2428,2518,2563,2608,2665,2736,2766,2894,2979,3076,3153,3216,
        3261,3326,3398,1,6,0,0
    ];

    private static __ATN: antlr.ATN;
    public static get _ATN(): antlr.ATN {
        if (!SubjectsVariablesLexer.__ATN) {
            SubjectsVariablesLexer.__ATN = new antlr.ATNDeserializer().deserialize(SubjectsVariablesLexer._serializedATN);
        }

        return SubjectsVariablesLexer.__ATN;
    }


    private static readonly vocabulary = new antlr.Vocabulary(SubjectsVariablesLexer.literalNames, SubjectsVariablesLexer.symbolicNames, []);

    public override get vocabulary(): antlr.Vocabulary {
        return SubjectsVariablesLexer.vocabulary;
    }

    private static readonly decisionsToDFA = SubjectsVariablesLexer._ATN.decisionToState.map( (ds: antlr.DecisionState, index: number) => new antlr.DFA(ds, index) );
}